{
  "exportHeading": {
    "name": "exportHeading",
    "characters": "Transactions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tabSelectedInboxCredit": {
    "name": "tabSelectedInboxCredit",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "tabInboxCustomerSuccess": {
    "name": "tabInboxCustomerSuccess",
    "characters": "Customer success",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tabInboxCreditAll": {
    "name": "tabInboxCreditAll",
    "characters": "All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tabInboxCreditCardCreditRequest": {
    "name": "tabInboxCreditCardCreditRequest",
    "characters": "Card credit request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tabInboxCreditCompanyCredit": {
    "name": "tabInboxCreditCompanyCredit",
    "characters": "Company credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tabInboxCreditCardCreditRepaymentInvoice": {
    "name": "tabInboxCreditCardCreditRepaymentInvoice",
    "characters": "Card credit RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "tabInboxCreditCompanyCreditRepaymentInvoice": {
    "name": "tabInboxCreditCompanyCreditRepaymentInvoice",
    "characters": "Company credit RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Looks like you’re all caught up!": {
    "name": "Looks like you’re all caught up!",
    "characters": "Looks like you’re all caught up!",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "Default": {
    "name": "Default",
    "characters": "Default",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Credit > All": {
    "name": "Credit > All",
    "characters": "Credit > All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Customer success > All": {
    "name": "Customer success > All",
    "characters": "Customer success > All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Miscellaneous> All": {
    "name": "Miscellaneous> All",
    "characters": "Miscellaneous> All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Modals": {
    "name": "Modals",
    "characters": "Modals",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Icons": {
    "name": "Icons",
    "characters": "Icons",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Hover (icons)": {
    "name": "Hover (icons)",
    "characters": "Hover (icons)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Active": {
    "name": "Active",
    "characters": "Active",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Selected": {
    "name": "Selected",
    "characters": "Selected",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "inboxTabCredit": {
    "name": "inboxTabCredit",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxTabCustomerSuccess": {
    "name": "inboxTabCustomerSuccess",
    "characters": "Customer success",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabMiscellaneous": {
    "name": "inboxTabMiscellaneous",
    "characters": "Miscellaneous",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxTabCreditAll": {
    "name": "inboxTabCreditAll",
    "characters": "All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCreditCardCreditRequest": {
    "name": "inboxTabCreditCardCreditRequest",
    "characters": "Card credit request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxTabCreditCompanyCredit": {
    "name": "inboxTabCreditCompanyCredit",
    "characters": "Company credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCreditCardCreditRepaymentInvoice": {
    "name": "inboxTabCreditCardCreditRepaymentInvoice",
    "characters": "Card credit RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCreditCompanyCreditRepaymentInvoice": {
    "name": "inboxTabCreditCompanyCreditRepaymentInvoice",
    "characters": "Company credit RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Show": {
    "name": "Show",
    "characters": "Show",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inputPlaceHolderSearchEvent": {
    "name": "inputPlaceHolderSearchEvent",
    "characters": "Search event...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditLabelCardCreditRepaymentInvoice": {
    "name": "inboxCreditLabelCardCreditRepaymentInvoice",
    "characters": "card_credit_RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCreditCardCreditRepaymentInvoiceHeadingCompanyName": {
    "name": "inboxCreditCardCreditRepaymentInvoiceHeadingCompanyName",
    "characters": "Mynt AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.4px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxCreditCardCreditRepaymentInvoiceInformationStatus": {
    "name": "inboxCreditCardCreditRepaymentInvoiceInformationStatus",
    "characters": "Repayment invoice overdue by - 5 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCardCreditRepaymentInvoiceAction": {
    "name": "inboxCreditCardCreditRepaymentInvoiceAction",
    "characters": "Remind or collect debt",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditLabelCardCreditRequest": {
    "name": "inboxCreditLabelCardCreditRequest",
    "characters": "card_credit_request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCreditCardCreditRequestHeadingCompanyName": {
    "name": "inboxCreditCardCreditRequestHeadingCompanyName",
    "characters": "Mynt AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.4px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxCreditCardCreditRequestInformationStatus": {
    "name": "inboxCreditCardCreditRequestInformationStatus",
    "characters": "OnboardingFlowInterestedForm",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditInformationAction": {
    "name": "inboxCreditCompanyCreditInformationAction",
    "characters": "Approve or deny",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCardCreditRequestInformationAmount": {
    "name": "inboxCreditCardCreditRequestInformationAmount",
    "characters": "SEK 10,000.00",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditLabelCompanyCreditRepaymentInvoice": {
    "name": "inboxCreditLabelCompanyCreditRepaymentInvoice",
    "characters": "company_credit_RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditRepaymentInvoiceHeadingCompanyName": {
    "name": "inboxCreditCompanyCreditRepaymentInvoiceHeadingCompanyName",
    "characters": "Mynt AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.4px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditRepaymentInvoiceInformationStatus": {
    "name": "inboxCreditCompanyCreditRepaymentInvoiceInformationStatus",
    "characters": "[OVER_DUE], no reminders: 1, synced with fortnox",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditRepaymentInvoiceAction": {
    "name": "inboxCreditCompanyCreditRepaymentInvoiceAction",
    "characters": "Remind or collect debt",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditRepaymentInvoiceInformationAmount": {
    "name": "inboxCreditCompanyCreditRepaymentInvoiceInformationAmount",
    "characters": "SEK 6,750.00, credit no 1843",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditLabelCompanyCredit": {
    "name": "inboxCreditLabelCompanyCredit",
    "characters": "company_credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditHeadingCompanyName": {
    "name": "inboxCreditCompanyCreditHeadingCompanyName",
    "characters": "Mynt AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.4px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditInformationStatus": {
    "name": "inboxCreditCompanyCreditInformationStatus",
    "characters": "CUSTOMER_ACCEPTED ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditAction": {
    "name": "inboxCreditCompanyCreditAction",
    "characters": "Payout",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCreditCompanyCreditInformationAmount": {
    "name": "inboxCreditCompanyCreditInformationAmount",
    "characters": "SEK 125,000.00 ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "Credit > Card credit request": {
    "name": "Credit > Card credit request",
    "characters": "Credit > Card credit request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-3px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "modalReminderSubHeadingPenaltyAmountsPlural": {
    "name": "modalReminderSubHeadingPenaltyAmountsPlural",
    "characters": "Penalty amount for [8] companies",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalReminderTextReminder": {
    "name": "modalReminderTextReminder",
    "characters": "Send reminder to all companies.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "modalReminderHeadingReminder": {
    "name": "modalReminderHeadingReminder",
    "characters": "Reminder",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalReminderInputLabelPenaltyAmount": {
    "name": "modalReminderInputLabelPenaltyAmount",
    "characters": "Penalty amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalReminderInputPlaceHolderPenaltyAmount": {
    "name": "modalReminderInputPlaceHolderPenaltyAmount",
    "characters": "500",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "modalReminderInputCurrencyPenaltyAmount": {
    "name": "modalReminderInputCurrencyPenaltyAmount",
    "characters": "kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "modalReminderButtonSubmit": {
    "name": "modalReminderButtonSubmit",
    "characters": "Submit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalSnoozeHeadingSnooze": {
    "name": "modalSnoozeHeadingSnooze",
    "characters": "Snooze",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalSnoozeInputLabelUntilDate": {
    "name": "modalSnoozeInputLabelUntilDate",
    "characters": "Until date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalReminderInputPlaceHolderDate": {
    "name": "modalReminderInputPlaceHolderDate",
    "characters": "åååå-mm-dd",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "modalSnoozeButtonSnooze": {
    "name": "modalSnoozeButtonSnooze",
    "characters": "Snooze",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalCollectDebtHeadingAreYouSure": {
    "name": "modalCollectDebtHeadingAreYouSure",
    "characters": "Are you sure?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modalCollectDebtTextAreYouSure": {
    "name": "modalCollectDebtTextAreYouSure",
    "characters": "Yes",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "areYourSureCancelButton": {
    "name": "areYourSureCancelButton",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tabSelected": {
    "name": "tabSelected",
    "characters": "Vouchers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCSS": {
    "name": "inboxTabCSS",
    "characters": "Customer success",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxTabCSSAll": {
    "name": "inboxTabCSSAll",
    "characters": "All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxTabCSSEnfucePayout": {
    "name": "inboxTabCSSEnfucePayout",
    "characters": "Enfuce payout",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCSPeMonthlyReport": {
    "name": "inboxTabCSPeMonthlyReport",
    "characters": "PE monthly report",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCSSCustomer": {
    "name": "inboxTabCSSCustomer",
    "characters": "Customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCSSAutoTopUp": {
    "name": "inboxTabCSSAutoTopUp",
    "characters": "Auto Top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCSSAutogiroApproval": {
    "name": "inboxTabCSSAutogiroApproval",
    "characters": "Autogiro approval",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxTabCSSRequestForPayment": {
    "name": "inboxTabCSSRequestForPayment",
    "characters": "Request for payment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxCSSLabelEnfucePayout": {
    "name": "inboxCSSLabelEnfucePayout",
    "characters": "enfuce_payout",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCSSEnfucePayoutHeadingCompanyName": {
    "name": "inboxCSSEnfucePayoutHeadingCompanyName",
    "characters": "Mynt AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.4px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "inboxCSSEnfucePayoutAction": {
    "name": "inboxCSSEnfucePayoutAction",
    "characters": "Book or cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSEnfucePayoutInformationAmount": {
    "name": "inboxCSSEnfucePayoutInformationAmount",
    "characters": "SEK 5,000.00 ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSLabelPeMonthlyReport": {
    "name": "inboxCSSLabelPeMonthlyReport",
    "characters": "pe_monthly_report",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCSSPeMonthlyReportInformationStatus": {
    "name": "inboxCSSPeMonthlyReportInformationStatus",
    "characters": "Missing for 2022-December",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSPeMonthlyReportAction": {
    "name": "inboxCSSPeMonthlyReportAction",
    "characters": "Manually trigger a report",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSLabelCustomer": {
    "name": "inboxCSSLabelCustomer",
    "characters": "customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCSSCustomerInformationStatus": {
    "name": "inboxCSSCustomerInformationStatus",
    "characters": "[PENDING]change products from [COMPANY_CREDIT, MULTI_INVOICE_CREDIT, CARD_CREDIT] to [COMPANY_CREDIT, MULTI_INVOICE_CREDIT, CARD, CARD_CREDIT]",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSCustomerAction": {
    "name": "inboxCSSCustomerAction",
    "characters": "Approve or deny",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSCustomerInformationAmount": {
    "name": "inboxCSSCustomerInformationAmount",
    "characters": "SEK 0.00",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSLabelAutoTopUp": {
    "name": "inboxCSSLabelAutoTopUp",
    "characters": "auto_topup",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCSSAutoTopUpAction": {
    "name": "inboxCSSAutoTopUpAction",
    "characters": "Approve or deny",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSAutoTopUpInformationAmount": {
    "name": "inboxCSSAutoTopUpInformationAmount",
    "characters": "SEK 10,000.00 / 15,000.00",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSLabelAutogiroApproval": {
    "name": "inboxCSSLabelAutogiroApproval",
    "characters": "autogiro_approval",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCSSAutogiroApprovalInformationStatus": {
    "name": "inboxCSSAutogiroApprovalInformationStatus",
    "characters": "It’s been a few days and no approval has been received",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSAutogiroApprovalAction": {
    "name": "inboxCSSAutogiroApprovalAction",
    "characters": "Sent to Billecta Created",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSAutogiroApprovalInformationAmount": {
    "name": "inboxCSSAutogiroApprovalInformationAmount",
    "characters": "SEK 6,750.00, credit no 1843",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSLabelRequestForPayment": {
    "name": "inboxCSSLabelRequestForPayment",
    "characters": "request_for_payment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.4px",
          "lineHeight": "14.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "inboxCSSRequestForPaymentInformationStatus": {
    "name": "inboxCSSRequestForPaymentInformationStatus",
    "characters": "Overdue by -14 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxCSSRequestForPaymentAction": {
    "name": "inboxCSSRequestForPaymentAction",
    "characters": "Investigate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inboxTabMiscAll": {
    "name": "inboxTabMiscAll",
    "characters": "All",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "transactionToolTipLatestNote": {
    "name": "transactionToolTipLatestNote",
    "characters": "Note",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "hoverBook": {
    "name": "hoverBook",
    "characters": "Book",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "hoverSnooze": {
    "name": "hoverSnooze",
    "characters": "Snooze",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "hoverDebtCollection": {
    "name": "hoverDebtCollection",
    "characters": "Debt collection",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "hoverSendReminder": {
    "name": "hoverSendReminder",
    "characters": "Send reminder",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "snoozeDropDownOption01": {
    "name": "snoozeDropDownOption01",
    "characters": "1 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "snoozeDropDownOption02": {
    "name": "snoozeDropDownOption02",
    "characters": "3 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "snoozeDropDownOption03": {
    "name": "snoozeDropDownOption03",
    "characters": "5 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "snoozeDropDownOption04": {
    "name": "snoozeDropDownOption04",
    "characters": "7 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "snoozeDropDownOptionCustom": {
    "name": "snoozeDropDownOptionCustom",
    "characters": "Custom",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "selectOptionShowAll": {
    "name": "selectOptionShowAll",
    "characters": "Show all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "selectOptionShowSnoozed": {
    "name": "selectOptionShowSnoozed",
    "characters": "Show snoozed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "selectOptionShowStarred": {
    "name": "selectOptionShowStarred",
    "characters": "Show starred",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "selectHoverSelectAll": {
    "name": "selectHoverSelectAll",
    "characters": "Select all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "navBarCustomersGeneral": {
    "name": "navBarCustomersGeneral",
    "characters": "General",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardProduct": {
    "name": "cardProduct",
    "characters": "Card product",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 600,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardCreditProductSendWelcomeEmail": {
    "name": "cardCreditProductSendWelcomeEmail",
    "characters": "Send welcome email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "companyCreditProduct": {
    "name": "companyCreditProduct",
    "characters": "Company credit product",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 600,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Helper text": {
    "name": "Helper text",
    "characters": "Helper text",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "18px",
          "color": "rgba(26, 26, 26, 1)"
        }
      }
    }
  },
  "customersGeneralSubscriptionHeading": {
    "name": "customersGeneralSubscriptionHeading",
    "characters": "Subscription",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersGeneralSubscriptionHeadingLabelPricingPlanOptionEssential": {
    "name": "customersGeneralSubscriptionHeadingLabelPricingPlanOptionEssential",
    "characters": "Essential",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersGeneralSubscriptionHeadingLabelPricingPlan": {
    "name": "customersGeneralSubscriptionHeadingLabelPricingPlan",
    "characters": "Pricing plan",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inputFieldPlaceholder": {
    "name": "inputFieldPlaceholder",
    "characters": "8293829",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersGeneralGeneralInfoHeading": {
    "name": "customersGeneralGeneralInfoHeading",
    "characters": "> \"\":[...]1 item",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyNameLabel": {
    "name": "companyNameLabel",
    "characters": "Company name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "inputFieldLabelName": {
    "name": "inputFieldLabelName",
    "characters": "Company ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "addressLabel": {
    "name": "addressLabel",
    "characters": "Address",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "postalCodeLabel": {
    "name": "postalCodeLabel",
    "characters": "Postal code",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "tooltipTextRefreshAddress": {
    "name": "tooltipTextRefreshAddress",
    "characters": "Refresh address",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountTypeDropdownLabel": {
    "name": "customersCardOverviewAccountTypeDropdownLabel",
    "characters": "Account type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountTypeDropdownLabelPlatinum": {
    "name": "customersCardOverviewAccountTypeDropdownLabelPlatinum",
    "characters": "Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewEnfuseAcccountHeading": {
    "name": "customersCardOverviewEnfuseAcccountHeading",
    "characters": "Enfuce account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountStatusBadge": {
    "name": "customersCardOverviewAccountStatusBadge",
    "characters": "Status ok",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountSettledBalanceLabel": {
    "name": "customersCardOverviewAccountSettledBalanceLabel",
    "characters": "Settled balance",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountSettledBalanceLabelValue": {
    "name": "customersCardOverviewAccountSettledBalanceLabelValue",
    "characters": "-26 451 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountAvailableToSpendLable": {
    "name": "customersCardOverviewAccountAvailableToSpendLable",
    "characters": "Available to spend",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountAvailableToSpendLableValue": {
    "name": "customersCardOverviewAccountAvailableToSpendLableValue",
    "characters": "-50 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountCreditLimitLable": {
    "name": "customersCardOverviewAccountCreditLimitLable",
    "characters": "Credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountCreditLimitLableValue": {
    "name": "customersCardOverviewAccountCreditLimitLableValue",
    "characters": "23 549 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountNameTitle": {
    "name": "customersCardOverviewAccountNameTitle",
    "characters": "Name:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewAccountNameInfo": {
    "name": "customersCardOverviewAccountNameInfo",
    "characters": "Card Account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewEnfuseCustomerEntityHeading": {
    "name": "customersCardOverviewEnfuseCustomerEntityHeading",
    "characters": "Enfuce customer entity",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "notSubmittedBadge": {
    "name": "notSubmittedBadge",
    "characters": "Not submitted",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCustomerRepresentative": {
    "name": "overviewCorporateCustomerColumnCustomerRepresentative",
    "characters": "Customer representative:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerCustomerColumnRepresentativeValue": {
    "name": "overviewCorporateCustomerCustomerColumnRepresentativeValue",
    "characters": "Nick Coloman",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnRole": {
    "name": "overviewCorporateCustomerColumnRole",
    "characters": "Role:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "xxxxxxxxxxxxxxxxxxxxxxxxx": {
    "name": "xxxxxxxxxxxxxxxxxxxxxxxxx",
    "characters": "XX-XXX XXX XX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnLocale": {
    "name": "overviewCorporateCustomerColumnLocale",
    "characters": "Locale:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnLocaleValue": {
    "name": "overviewCorporateCustomerColumnLocaleValue",
    "characters": "sv_SE",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnName": {
    "name": "overviewCorporateCustomerColumnName",
    "characters": "Name:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnNameValue": {
    "name": "overviewCorporateCustomerColumnNameValue",
    "characters": "Mynt AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnEmail": {
    "name": "overviewCorporateCustomerColumnEmail",
    "characters": "Email:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnEmailValue": {
    "name": "overviewCorporateCustomerColumnEmailValue",
    "characters": "info@mynt.se",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnPhoneNumber": {
    "name": "overviewCorporateCustomerColumnPhoneNumber",
    "characters": "Phone number:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnPhoneNumberValue": {
    "name": "overviewCorporateCustomerColumnPhoneNumberValue",
    "characters": "XX-XXX XXX XX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnMobile": {
    "name": "overviewCorporateCustomerColumnMobile",
    "characters": "Mobile:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnMobileValue": {
    "name": "overviewCorporateCustomerColumnMobileValue",
    "characters": "XX-XXX XXX XX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnAdress1": {
    "name": "overviewCorporateCustomerColumnAdress1",
    "characters": "Adress 1:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnAdress1Value": {
    "name": "overviewCorporateCustomerColumnAdress1Value",
    "characters": "c/o Krongatan 1",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnAdress2": {
    "name": "overviewCorporateCustomerColumnAdress2",
    "characters": "Adress 2:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnAdress2Value": {
    "name": "overviewCorporateCustomerColumnAdress2Value",
    "characters": "c/o Peng",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCity": {
    "name": "overviewCorporateCustomerColumnCity",
    "characters": "City:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCityValue": {
    "name": "overviewCorporateCustomerColumnCityValue",
    "characters": "Boden",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnZipCode": {
    "name": "overviewCorporateCustomerColumnZipCode",
    "characters": "Zip code:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnZipCodeValue": {
    "name": "overviewCorporateCustomerColumnZipCodeValue",
    "characters": "XXX XX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCountry": {
    "name": "overviewCorporateCustomerColumnCountry",
    "characters": "Country:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCountryValue": {
    "name": "overviewCorporateCustomerColumnCountryValue",
    "characters": "SWE",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCustomerNumber": {
    "name": "overviewCorporateCustomerColumnCustomerNumber",
    "characters": "Customer number:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnCustomerNumberValue": {
    "name": "overviewCorporateCustomerColumnCustomerNumberValue",
    "characters": "xxxxxxxxxxxxxxxxxxxxxxxxx",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnRegNo": {
    "name": "overviewCorporateCustomerColumnRegNo",
    "characters": "Reg. no:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewCorporateCustomerColumnRegNoValue": {
    "name": "overviewCorporateCustomerColumnRegNoValue",
    "characters": "XXXXXX-XXXX_XXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardHeading": {
    "name": "customersCardOverviewCardHeading",
    "characters": "Cards",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "searchHeaderPlaceholder": {
    "name": "searchHeaderPlaceholder",
    "characters": "Search...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableCardHolder": {
    "name": "customersCardOverviewCardsTableLableCardHolder",
    "characters": "Card holder",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableCardNumber": {
    "name": "customersCardOverviewCardsTableLableCardNumber",
    "characters": "Card number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableStatus": {
    "name": "customersCardOverviewCardsTableLableStatus",
    "characters": "Status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableTemplate": {
    "name": "customersCardOverviewCardsTableLableTemplate",
    "characters": "Template",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableId": {
    "name": "customersCardOverviewCardsTableLableId",
    "characters": "ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableCardHolderValue": {
    "name": "customersCardOverviewCardsTableLableCardHolderValue",
    "characters": "Name Nameson",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableCardNumberValue": {
    "name": "customersCardOverviewCardsTableLableCardNumberValue",
    "characters": "XXXXXX______XXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableStatusValue": {
    "name": "customersCardOverviewCardsTableLableStatusValue",
    "characters": "CARD_CLOSED",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableTemplateValue": {
    "name": "customersCardOverviewCardsTableLableTemplateValue",
    "characters": "XXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewCardsTableLableIdValue": {
    "name": "customersCardOverviewCardsTableLableIdValue",
    "characters": "XXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Rows per page": {
    "name": "Rows per page",
    "characters": "Rows per page",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "100 rows": {
    "name": "100 rows",
    "characters": "100 rows",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "1 of 1": {
    "name": "1 of 1",
    "characters": "1 of 1",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardOverviewPrivateCustomersHeading": {
    "name": "customersCardOverviewPrivateCustomersHeading",
    "characters": "Private customers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewPrivateCustomersFirstName1Column": {
    "name": "customersCardOverviewPrivateCustomersFirstName1Column",
    "characters": "First name:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewPrivateCustomersFirstName1ColumnValue": {
    "name": "customersCardOverviewPrivateCustomersFirstName1ColumnValue",
    "characters": "Anna",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewPrivateCustomersAdress1Column": {
    "name": "customersCardOverviewPrivateCustomersAdress1Column",
    "characters": "Adress 1:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewPrivateCustomersAdress1ColumnValue": {
    "name": "customersCardOverviewPrivateCustomersAdress1ColumnValue",
    "characters": "c/o Krongatan 1",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewPrivateCustomersColumnId": {
    "name": "overviewPrivateCustomersColumnId",
    "characters": "ID:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewPrivateCustomersColumnIdValue": {
    "name": "overviewPrivateCustomersColumnIdValue",
    "characters": "XXXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewPrivateCustomersColumnLocale": {
    "name": "overviewPrivateCustomersColumnLocale",
    "characters": "Locale:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "overviewPrivateCustomersColumnLocaleValue": {
    "name": "overviewPrivateCustomersColumnLocaleValue",
    "characters": "sv_SE",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "textCardOverviewPrivateCustomersMobileNumber": {
    "name": "textCardOverviewPrivateCustomersMobileNumber",
    "characters": "Mobile:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsHeading": {
    "name": "customersCardOverviewUsageLimitsHeading",
    "characters": "Usage limits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsWeeklyHeading": {
    "name": "customersCardOverviewUsageLimitsWeeklyHeading",
    "characters": "Weekly",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableCode": {
    "name": "customersCardOverviewUsageLimitsTableLableCode",
    "characters": "Code",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableCount": {
    "name": "customersCardOverviewUsageLimitsTableLableCount",
    "characters": "Count",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableSingleAmount": {
    "name": "customersCardOverviewUsageLimitsTableLableSingleAmount",
    "characters": "Single amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableSumAmount": {
    "name": "customersCardOverviewUsageLimitsTableLableSumAmount",
    "characters": "Sum amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableCodeValue": {
    "name": "customersCardOverviewUsageLimitsTableLableCodeValue",
    "characters": "ALL",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableCountValue": {
    "name": "customersCardOverviewUsageLimitsTableLableCountValue",
    "characters": "XXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableSingleAmountValue": {
    "name": "customersCardOverviewUsageLimitsTableLableSingleAmountValue",
    "characters": "-",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardOverviewUsageLimitsTableLableSumAmountValue": {
    "name": "customersCardOverviewUsageLimitsTableLableSumAmountValue",
    "characters": "-",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "usageLimitsTableColumnHeadingCodeAtmValue": {
    "name": "usageLimitsTableColumnHeadingCodeAtmValue",
    "characters": "ALL",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "usageLimitsTableColumnHeadingCountAllValue": {
    "name": "usageLimitsTableColumnHeadingCountAllValue",
    "characters": "XXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "usageLimitsTableColumnHeadingSingleAmountAllValue": {
    "name": "usageLimitsTableColumnHeadingSingleAmountAllValue",
    "characters": "-",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "usageLimitsTableColumnHeadingSumAmountAllValue": {
    "name": "usageLimitsTableColumnHeadingSumAmountAllValue",
    "characters": "-",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Monthly": {
    "name": "Monthly",
    "characters": "Monthly",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tooltipEnablePlatinumAccountText": {
    "name": "tooltipEnablePlatinumAccountText",
    "characters": "Enable Platinum account, if you enable you can not go back to Prepaid account.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "OLD VERSION": {
    "name": "OLD VERSION",
    "characters": "OLD VERSION",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "24px",
          "fontWeight": 700,
          "letterSpacing": "-0.5px",
          "lineHeight": "33.6px",
          "color": "rgba(255, 128, 87, 1)"
        }
      }
    }
  },
  "cardsTableColumnHeadingCardHolder": {
    "name": "cardsTableColumnHeadingCardHolder",
    "characters": "Card holder",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "cardsTableColumnCardHolderValue": {
    "name": "cardsTableColumnCardHolderValue",
    "characters": "Name Nameson",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardsTableColumnCardNumberValue": {
    "name": "cardsTableColumnCardNumberValue",
    "characters": "XXXXXX______XXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardsTableColumnCardStatusValue": {
    "name": "cardsTableColumnCardStatusValue",
    "characters": "CARD_CLOSED",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardsTableColumnTypeValue": {
    "name": "cardsTableColumnTypeValue",
    "characters": "XXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardsTableColumnIdValue": {
    "name": "cardsTableColumnIdValue",
    "characters": "XXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTransactionsHeading": {
    "name": "customersCardTransactionsTransactionsHeading",
    "characters": "Transactions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableLableDate": {
    "name": "customersCardTransactionsTableLableDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableLableVendor": {
    "name": "customersCardTransactionsTableLableVendor",
    "characters": "Vendor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableLableAmount": {
    "name": "customersCardTransactionsTableLableAmount",
    "characters": "Amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableLableAccountId": {
    "name": "customersCardTransactionsTableLableAccountId",
    "characters": "Account id",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableLableActions": {
    "name": "customersCardTransactionsTableLableActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableValue": {
    "name": "customersCardTransactionsTableValue",
    "characters": "XXXX-XX-XX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardTransactionsVendorValue": {
    "name": "customersCardTransactionsVendorValue",
    "characters": "Facebook woods",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableAmountValue": {
    "name": "customersCardTransactionsTableAmountValue",
    "characters": "-XXXXX kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardTransactionsTableAccountIdValue": {
    "name": "customersCardTransactionsTableAccountIdValue",
    "characters": "XXXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardPayoutsPayoutsHeading": {
    "name": "customersCardPayoutsPayoutsHeading",
    "characters": "Payouts",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardPayoutsInputFieldAddTopUpValue": {
    "name": "customersCardPayoutsInputFieldAddTopUpValue",
    "characters": "10 000",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardPayoutsInputFieldAddTopUpCurrency": {
    "name": "customersCardPayoutsInputFieldAddTopUpCurrency",
    "characters": "kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardPayoutsInputFieldLabelAddTopUp": {
    "name": "customersCardPayoutsInputFieldLabelAddTopUp",
    "characters": "Add top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableBookedLabel": {
    "name": "customersCardPayoutsTableBookedLabel",
    "characters": "Booked",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableState": {
    "name": "customersCardPayoutsTableLableState",
    "characters": "State",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableCustomer": {
    "name": "customersCardPayoutsTableLableCustomer",
    "characters": "Customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableAmmountSek": {
    "name": "customersCardPayoutsTableLableAmmountSek",
    "characters": "Ammount SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLablePayoutType": {
    "name": "customersCardPayoutsTableLablePayoutType",
    "characters": "Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableSubtype": {
    "name": "customersCardPayoutsTableLableSubtype",
    "characters": "Subtype",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableActions": {
    "name": "customersCardPayoutsTableLableActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableDate": {
    "name": "customersCardPayoutsTableLableDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableExternalreference": {
    "name": "customersCardPayoutsTableLableExternalreference",
    "characters": "External reference",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableType": {
    "name": "customersCardPayoutsTableLableType",
    "characters": "Account type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableLableEnfuceId": {
    "name": "customersCardPayoutsTableLableEnfuceId",
    "characters": "Enfuce id",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableDropdownPlatinum": {
    "name": "customersCardPayoutsTableDropdownPlatinum",
    "characters": "Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardPayoutsTableDropdownPrepaid": {
    "name": "customersCardPayoutsTableDropdownPrepaid",
    "characters": "Prepaid",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsHeading": {
    "name": "customersCardCreditOnCardCreditSettingsHeading",
    "characters": "Credit settings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditOnCardCreditSettingsPrepaidHeading": {
    "name": "creditOnCardCreditSettingsPrepaidHeading",
    "characters": "Prepaid",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidLabelCurrentCreditLimit": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidLabelCurrentCreditLimit",
    "characters": "Credit number:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidCurrentCreditLimitValue": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidCurrentCreditLimitValue",
    "characters": "12345",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidUpdateCredit": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidUpdateCredit",
    "characters": "Update credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidUpdateCreditLabelCreditState": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidUpdateCreditLabelCreditState",
    "characters": "Credit state",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidUpdateCreditSetCreditState": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidUpdateCreditSetCreditState",
    "characters": "Set credit state",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidLableCreditLimit": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidLableCreditLimit",
    "characters": "Credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPrepaidSetCreditLimit": {
    "name": "customersCardCreditOnCardCreditSettingsPrepaidSetCreditLimit",
    "characters": "Set credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customerCardCreditLimitFeeRateLabel": {
    "name": "customerCardCreditLimitFeeRateLabel",
    "characters": "Credit limit fee rate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customerCardCreditLimitFeeRateValue": {
    "name": "customerCardCreditLimitFeeRateValue",
    "characters": "Set credit limit fee rate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditOnCardCreditSettingsPlatinumHeading": {
    "name": "creditOnCardCreditSettingsPlatinumHeading",
    "characters": "Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumLabelCurrentCreditLimit": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumLabelCurrentCreditLimit",
    "characters": "Current credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumCurrentCreditLimitValue": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumCurrentCreditLimitValue",
    "characters": "50 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumUpdateCredit": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumUpdateCredit",
    "characters": "Update credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumUpdateCreditLabelCreditState": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumUpdateCreditLabelCreditState",
    "characters": "Low balance alert status by costumer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumUpdateCreditSetCreditState": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumUpdateCreditSetCreditState",
    "characters": "Set credit state",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumLableCreditLimit": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumLableCreditLimit",
    "characters": "Credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditSettingsPlatinumSetCreditLimit": {
    "name": "customersCardCreditOnCardCreditSettingsPlatinumSetCreditLimit",
    "characters": "Set credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardCreditOnCardCreditAgreementHeading": {
    "name": "customersCardCreditOnCardCreditAgreementHeading",
    "characters": "Credit agreement",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditAgreementSignatoriesPlaceholder": {
    "name": "creditAgreementSignatoriesPlaceholder",
    "characters": "Choose a signatory",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementPaymentMethodLabel": {
    "name": "setUpCreditAgreementPaymentMethodLabel",
    "characters": "Payment method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementPaymentMethodMobile": {
    "name": "setUpCreditAgreementPaymentMethodMobile",
    "characters": " Mobile",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "rightMenuTransactionAddParticipantLink": {
    "name": "rightMenuTransactionAddParticipantLink",
    "characters": "Add company guarantor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "creditOnCardAddCompanyGuarantor": {
    "name": "creditOnCardAddCompanyGuarantor",
    "characters": "Add company guarantor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "enablePlatinumAccountToggleTitle": {
    "name": "enablePlatinumAccountToggleTitle",
    "characters": "Enable Platinum account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modaleEnablePlatinumAccountHeader": {
    "name": "modaleEnablePlatinumAccountHeader",
    "characters": "Enable Platinum account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modaleEnablePlatinumAccountText": {
    "name": "modaleEnablePlatinumAccountText",
    "characters": "Are you sure you want to enable Platinum account? All future topups and card orders will be on the Platinum account. This cannot be reversed.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "modaleEnablePlatinumCancelButton": {
    "name": "modaleEnablePlatinumCancelButton",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "modaleEnablePlatinumAcceptButton": {
    "name": "modaleEnablePlatinumAcceptButton",
    "characters": "Yes, enable Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardLowBalanceAlertHeading": {
    "name": "customersCardLowBalanceAlertHeading",
    "characters": "Low balance alert",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardLowBalanceAlertSetLowBalanceAlertLimitHeading": {
    "name": "customersCardLowBalanceAlertSetLowBalanceAlertLimitHeading",
    "characters": "Set low balance alert limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "x": {
    "name": "x",
    "characters": "0",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardLowBalanceAlertSetLowBalanceAlertLabelWhenBalanceFallsBelow": {
    "name": "customersCardLowBalanceAlertSetLowBalanceAlertLabelWhenBalanceFallsBelow",
    "characters": "When balance falls below",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardLowBalanceAlertSetLowBalanceAlertDetailsHeading": {
    "name": "customersCardLowBalanceAlertSetLowBalanceAlertDetailsHeading",
    "characters": "Low balance alert details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardLowBalanceAlertSetLowBalanceAlertStatusSwitchDeactivate": {
    "name": "customersCardLowBalanceAlertSetLowBalanceAlertStatusSwitchDeactivate",
    "characters": "Deactivate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardLowBalanceAlertSetLowBalanceAlertStatusSwitchActivate": {
    "name": "customersCardLowBalanceAlertSetLowBalanceAlertStatusSwitchActivate",
    "characters": "Activate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpHeading": {
    "name": "customersCardAutoTopUpHeading",
    "characters": "Direct debit  - the view shoes 3 different scenarios.\nif there is no mandate agreements the section should collapse.\nAdd new icons to direct debit box for refresh and Cancel. Tooltip when hover.\nIf the checkbox for Send mandate agreement to customer is not checked (should be checked as default) then the modal with information “Are you sure” opens.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "44px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpSetAutoTopUpLimitsHeading": {
    "name": "customersCardAutoTopUpSetAutoTopUpLimitsHeading",
    "characters": "New direct debit connection",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "XXXXXX": {
    "name": "XXXXXX",
    "characters": "123456789",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpLabelTopUpWithTheFollowinAmount": {
    "name": "customersCardAutoTopUpLabelTopUpWithTheFollowinAmount",
    "characters": "Bank account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpButtonSetLimits": {
    "name": "customersCardAutoTopUpButtonSetLimits",
    "characters": "Send",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsHeading": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsHeading",
    "characters": "Direct debit details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsDirectDebitStatus": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsDirectDebitStatus",
    "characters": "Status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsDirectDebitStatusLabel": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsDirectDebitStatusLabel",
    "characters": "Inactive",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSet": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSet",
    "characters": "Auto top-up status set by customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSetDeactivate": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSetDeactivate",
    "characters": "Deactivate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSetActivate": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSetActivate",
    "characters": "Send mandate agreement to customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardAutoTopUpAutoTopUpDetailsBankAccountNumber": {
    "name": "customersCardAutoTopUpAutoTopUpDetailsBankAccountNumber",
    "characters": "Bank account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "XXXX-XXXXXXXXXX": {
    "name": "XXXX-XXXXXXXXXX",
    "characters": "XXXX-XXXXXXXXXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipSendWelcomeEmailHeading": {
    "name": "toolTipSendWelcomeEmailHeading",
    "characters": "Send welcome email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipSendWelcomeEmailText": {
    "name": "toolTipSendWelcomeEmailText",
    "characters": "Are your sure you want to send\nthe customer an welcome email?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipSendWelcomeEmailButtonNo": {
    "name": "toolTipSendWelcomeEmailButtonNo",
    "characters": "No",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "toolTipSendWelcomeEmailButtonYes": {
    "name": "toolTipSendWelcomeEmailButtonYes",
    "characters": "Yes",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuHeadingFilter": {
    "name": "transactionsFilterMenuHeadingFilter",
    "characters": "Filters",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "18px",
          "fontWeight": 700,
          "letterSpacing": "-0.5px",
          "lineHeight": "21.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuApplyFilters": {
    "name": "transactionsFilterMenuApplyFilters",
    "characters": "Apply filters",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.4px",
          "lineHeight": "15.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingAccountType": {
    "name": "transactionsFilterMenuSubHeadingAccountType",
    "characters": "Account type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardHolders": {
    "name": "transactionsFilterMenuSubHeadingCardHolders",
    "characters": "Card holders",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCards": {
    "name": "transactionsFilterMenuSubHeadingCards",
    "characters": "Cards",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingStatus": {
    "name": "transactionsFilterMenuSubHeadingStatus",
    "characters": "Status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuClear": {
    "name": "transactionsFilterMenuClear",
    "characters": "Clear",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingAccountTypePlaceHolderSearchField": {
    "name": "transactionsFilterMenuSubHeadingAccountTypePlaceHolderSearchField",
    "characters": "Search account type...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingAccountTypeSelectAll": {
    "name": "transactionsFilterMenuSubHeadingAccountTypeSelectAll",
    "characters": "Select all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingAccountTypeSelectPrepaid": {
    "name": "transactionsFilterMenuSubHeadingAccountTypeSelectPrepaid",
    "characters": "Prepaid ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingAccountTypeSelectPlatinum": {
    "name": "transactionsFilterMenuSubHeadingAccountTypeSelectPlatinum",
    "characters": "Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingAccountTypeSelectViewAll": {
    "name": "transactionsFilterMenuSubHeadingAccountTypeSelectViewAll",
    "characters": "View all...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardHoldersPlaceHolderSearchField": {
    "name": "transactionsFilterMenuSubHeadingCardHoldersPlaceHolderSearchField",
    "characters": "Search card holders...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardHoldersSelectAll": {
    "name": "transactionsFilterMenuSubHeadingCardHoldersSelectAll",
    "characters": "Select all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardHoldersSelectNameCardHolder": {
    "name": "transactionsFilterMenuSubHeadingCardHoldersSelectNameCardHolder",
    "characters": "Anders Jansson",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardHoldersSelectViewAll": {
    "name": "transactionsFilterMenuSubHeadingCardHoldersSelectViewAll",
    "characters": "View all...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsPlaceHolderSearchField": {
    "name": "transactionsFilterMenuSubHeadingCardsPlaceHolderSearchField",
    "characters": "Search cards...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsSelectAll": {
    "name": "transactionsFilterMenuSubHeadingCardsSelectAll",
    "characters": "Select all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsSelectCardValueVirtual": {
    "name": "transactionsFilterMenuSubHeadingCardsSelectCardValueVirtual",
    "characters": "7587",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsSelectCardValueVirtualCardHolderName": {
    "name": "transactionsFilterMenuSubHeadingCardsSelectCardValueVirtualCardHolderName",
    "characters": "Anders Jansson",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "15.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsSelectCardValuePhysical": {
    "name": "transactionsFilterMenuSubHeadingCardsSelectCardValuePhysical",
    "characters": "7601",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsSelectCardValuePhysicalCardHolderName": {
    "name": "transactionsFilterMenuSubHeadingCardsSelectCardValuePhysicalCardHolderName",
    "characters": "Anders Jansson",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "15.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingCardsSelectViewAll": {
    "name": "transactionsFilterMenuSubHeadingCardsSelectViewAll",
    "characters": "View all...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingStatusPlaceHolderSearchField": {
    "name": "transactionsFilterMenuSubHeadingStatusPlaceHolderSearchField",
    "characters": "Search status...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingStatusSelectAll": {
    "name": "transactionsFilterMenuSubHeadingStatusSelectAll",
    "characters": "Select all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingStatusSelectApproved": {
    "name": "transactionsFilterMenuSubHeadingStatusSelectApproved",
    "characters": "Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterMenuSubHeadingStatusSelectViewAll": {
    "name": "transactionsFilterMenuSubHeadingStatusSelectViewAll",
    "characters": "View all...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "TransactionsFilterClearAll": {
    "name": "TransactionsFilterClearAll",
    "characters": "Clear",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "searchTransactionPlaceholder": {
    "name": "searchTransactionPlaceholder",
    "characters": "Search transaction...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterCalendar": {
    "name": "transactionsFilterCalendar",
    "characters": "Jan 1 - May 5",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterFilters": {
    "name": "transactionsFilterFilters",
    "characters": "Filters",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsFilterFiltersValueNumber": {
    "name": "transactionsFilterFiltersValueNumber",
    "characters": "3",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "exportsFoundBadge": {
    "name": "exportsFoundBadge",
    "characters": "XXX transactions found",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelDate": {
    "name": "transactionsColumnLabelDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelVendor": {
    "name": "transactionsColumnLabelVendor",
    "characters": "Vendor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelAmount": {
    "name": "transactionsColumnLabelAmount",
    "characters": "Amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelCardHolder": {
    "name": "transactionsColumnLabelCardHolder",
    "characters": "Card holder",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelCard": {
    "name": "transactionsColumnLabelCard",
    "characters": "Card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelAccountType": {
    "name": "transactionsColumnLabelAccountType",
    "characters": "Account type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelTransactionStatus": {
    "name": "transactionsColumnLabelTransactionStatus",
    "characters": "Transaction",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnLabelActions": {
    "name": "transactionsColumnLabelActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "transactionsColumnDateValue": {
    "name": "transactionsColumnDateValue",
    "characters": "2021-04-16",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsColumnVendorValue": {
    "name": "transactionsColumnVendorValue",
    "characters": "Github.com",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsColumnAmountValueSek": {
    "name": "transactionsColumnAmountValueSek",
    "characters": "- 250 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsColumnAmountValueCurrency": {
    "name": "transactionsColumnAmountValueCurrency",
    "characters": "- 24 USD",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "14.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionsColumnCardHolderName": {
    "name": "transactionsColumnCardHolderName",
    "characters": "Anna Rijkeboer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsColumnCardVirtualNumber": {
    "name": "transactionsColumnCardVirtualNumber",
    "characters": "7587",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.2px",
          "lineHeight": "14.4px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "transactionsColumnAccountTypePrepaid": {
    "name": "transactionsColumnAccountTypePrepaid",
    "characters": "Prepaid",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsColumnCardPhysicalNumber": {
    "name": "transactionsColumnCardPhysicalNumber",
    "characters": "8383",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 600,
          "letterSpacing": "-0.2px",
          "lineHeight": "14.4px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "transactionsColumnAccountTypePlatinum": {
    "name": "transactionsColumnAccountTypePlatinum",
    "characters": "Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionsFilterFiltersDefault": {
    "name": "transactionsFilterFiltersDefault",
    "characters": "Filters",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionExportAsCSV": {
    "name": "transactionExportAsCSV",
    "characters": "Download as list (CSV)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionExportForExcel": {
    "name": "transactionExportForExcel",
    "characters": "Download as list (Excel)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionExportAsZip": {
    "name": "transactionExportAsZip",
    "characters": "Download with image (ZIP)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.5px",
          "lineHeight": "17.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendarCalender7Days": {
    "name": "filterCalendarCalender7Days",
    "characters": "Last 7 days",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendar1Month": {
    "name": "filterCalendar1Month",
    "characters": "Last month",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendar3Month": {
    "name": "filterCalendar3Month",
    "characters": "Last 3 month",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendar12Month": {
    "name": "filterCalendar12Month",
    "characters": "Last 12 month",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendarYearToDate": {
    "name": "filterCalendarYearToDate",
    "characters": "Year to date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendarAllTime": {
    "name": "filterCalendarAllTime",
    "characters": "All time",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalenderDateFromActive": {
    "name": "filterCalenderDateFromActive",
    "characters": "03 / 01 / 2021",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalenderDateToDefault": {
    "name": "filterCalenderDateToDefault",
    "characters": "03 / 04 / 2021",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay01": {
    "name": "filterCalendarWeekDay01",
    "characters": "M",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay02": {
    "name": "filterCalendarWeekDay02",
    "characters": "T",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay03": {
    "name": "filterCalendarWeekDay03",
    "characters": "W",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay04": {
    "name": "filterCalendarWeekDay04",
    "characters": "T",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay05": {
    "name": "filterCalendarWeekDay05",
    "characters": "F",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay06": {
    "name": "filterCalendarWeekDay06",
    "characters": "S",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarWeekDay07": {
    "name": "filterCalendarWeekDay07",
    "characters": "S",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarDatePassed": {
    "name": "filterCalendarDatePassed",
    "characters": "27",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "filterCalendarDateFuture": {
    "name": "filterCalendarDateFuture",
    "characters": "1",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalendarDateActive": {
    "name": "filterCalendarDateActive",
    "characters": "3",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "TransactionsDateFilterClear": {
    "name": "TransactionsDateFilterClear",
    "characters": "Clear",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "filterCalenderDateToActive": {
    "name": "filterCalenderDateToActive",
    "characters": "03 / 04 / 2021",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalenderDateFromDefault": {
    "name": "filterCalenderDateFromDefault",
    "characters": "03 / 01 / 2021",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "filterCalenderYear": {
    "name": "filterCalenderYear",
    "characters": "2017",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "filterCalenderYearActive": {
    "name": "filterCalenderYearActive",
    "characters": "2023",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersGeneralSubscriptionHeadingLabelPricingPlanOptionPremium": {
    "name": "customersGeneralSubscriptionHeadingLabelPricingPlanOptionPremium",
    "characters": "Premium",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "backofficeCustomersNavCard": {
    "name": "backofficeCustomersNavCard",
    "characters": "Card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "customersCardInvoicesCustomerInvoicesHeading": {
    "name": "customersCardInvoicesCustomerInvoicesHeading",
    "characters": "Customer invoices",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableInvoice": {
    "name": "customersCardInvoicesTableLableInvoice",
    "characters": "Invoice #",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableCraditNumber": {
    "name": "customersCardInvoicesTableLableCraditNumber",
    "characters": "Credit number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableState": {
    "name": "customersCardInvoicesTableLableState",
    "characters": "State",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableDate": {
    "name": "customersCardInvoicesTableLableDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableDueDate": {
    "name": "customersCardInvoicesTableLableDueDate",
    "characters": "Due date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableType": {
    "name": "customersCardInvoicesTableLableType",
    "characters": "Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableCustomer": {
    "name": "customersCardInvoicesTableLableCustomer",
    "characters": "Costumer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableDebit": {
    "name": "customersCardInvoicesTableLableDebit",
    "characters": "Debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableCredit": {
    "name": "customersCardInvoicesTableLableCredit",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableAccountType": {
    "name": "customersCardInvoicesTableLableAccountType",
    "characters": "Accounting method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customersCardInvoicesTableLableAction": {
    "name": "customersCardInvoicesTableLableAction",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoShowAll": {
    "name": "invoiceInfoAccountingInvoiceInfoShowAll",
    "characters": "Show all",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(42, 115, 255, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationSubscriptionFee": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationSubscriptionFee",
    "characters": "Subscription fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationSubscriptionFeeAmount": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationSubscriptionFeeAmount",
    "characters": "780 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationFixedCreditFee": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationFixedCreditFee",
    "characters": "Fixed credit limit fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationFixedCreditFeeAmount": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationFixedCreditFeeAmount",
    "characters": "780 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationAdministrationFee": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationAdministrationFee",
    "characters": "Administration fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationAdministrationAmount": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationAdministrationAmount",
    "characters": "780 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationCardsFee": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationCardsFee",
    "characters": "Cards fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationTravelInsuranceFee": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationTravelInsuranceFee",
    "characters": "Travel insurance fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingInvoiceInfoSpecificationCardOrderFee": {
    "name": "invoiceInfoAccountingInvoiceInfoSpecificationCardOrderFee",
    "characters": "Card order fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersCardInvoicesCustomerInvoicesCreditNumber": {
    "name": "customersCardInvoicesCustomerInvoicesCreditNumber",
    "characters": "Credit number:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "xxxxx": {
    "name": "xxxxx",
    "characters": "12345",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingType": {
    "name": "invoiceInfoAccountingType",
    "characters": "Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingTypeSubscriptionFee": {
    "name": "invoiceInfoAccountingTypeSubscriptionFee",
    "characters": "SUBSCRIPTION_FEE",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingMethod": {
    "name": "invoiceInfoAccountingMethod",
    "characters": "Method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoAccountingMethodValue": {
    "name": "invoiceInfoAccountingMethodValue",
    "characters": "Invoice method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesPDFHeading": {
    "name": "invoicesPDFHeading",
    "characters": "PDFs",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNamePaymentMethodCardAccount": {
    "name": "invoicesCreateInvoiceDropdownLabelNamePaymentMethodCardAccount",
    "characters": "Card account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownCardAccountPlatinum": {
    "name": "invoicesCreateInvoiceDropdownCardAccountPlatinum",
    "characters": "Platinum",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceVATCustomSelected": {
    "name": "invoicesCreateInvoiceVATCustomSelected",
    "characters": "Custom",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelCustomVAT": {
    "name": "invoicesCreateInvoiceLabelCustomVAT",
    "characters": "Custom VAT amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelCustomVATValueValue": {
    "name": "invoicesCreateInvoiceLabelCustomVATValueValue",
    "characters": "00.00",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNameSubFeeCurrencyXXX": {
    "name": "invoicesCreateInvoiceDropdownLabelNameSubFeeCurrencyXXX",
    "characters": "kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownSubFee": {
    "name": "invoicesCreateInvoiceDropdownSubFee",
    "characters": "Subscription fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownWithdrawal": {
    "name": "invoicesCreateInvoiceDropdownWithdrawal",
    "characters": "Withdrawal",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoCurrencyLabel": {
    "name": "mFinvoiceInfoCurrencyLabel",
    "characters": "SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownPaymentMethodCustomerMyntAccount": {
    "name": "invoicesCreateInvoiceDropdownPaymentMethodCustomerMyntAccount",
    "characters": "Customer Mynt account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownPaymentMethodInvoice": {
    "name": "invoicesCreateInvoiceDropdownPaymentMethodInvoice",
    "characters": "Invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownPaymentMethodAutogiro": {
    "name": "invoicesCreateInvoiceDropdownPaymentMethodAutogiro",
    "characters": "Autogiro",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownPaymentMethodSEPADirectDebit": {
    "name": "invoicesCreateInvoiceDropdownPaymentMethodSEPADirectDebit",
    "characters": "SEPA Direct Debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownCardAccountPrepaid": {
    "name": "invoicesCreateInvoiceDropdownCardAccountPrepaid",
    "characters": "Prepaid",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownCurrencySEK": {
    "name": "invoicesCreateInvoiceDropdownCurrencySEK",
    "characters": "SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownCurrencyEURO": {
    "name": "invoicesCreateInvoiceDropdownCurrencyEURO",
    "characters": "EURO",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceHeading": {
    "name": "invoicesCreateInvoiceHeading",
    "characters": "Create invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceSubHeadingCompanyName": {
    "name": "invoicesCreateInvoiceSubHeadingCompanyName",
    "characters": "Chokladfabriken AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNameInvoiceType": {
    "name": "invoicesCreateInvoiceDropdownLabelNameInvoiceType",
    "characters": "Invoice type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNamePaymentMethod": {
    "name": "invoicesCreateInvoiceDropdownLabelNamePaymentMethod",
    "characters": "Payment method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNameCurrency": {
    "name": "invoicesCreateInvoiceDropdownLabelNameCurrency",
    "characters": "Currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceSubHeadingInvoiceSpecs": {
    "name": "invoicesCreateInvoiceSubHeadingInvoiceSpecs",
    "characters": "Invoice specification",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNameSubFee": {
    "name": "invoicesCreateInvoiceDropdownLabelNameSubFee",
    "characters": "Subscription fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceDropdownLabelNameSubFeeValueXXX": {
    "name": "invoicesCreateInvoiceDropdownLabelNameSubFeeValueXXX",
    "characters": "780",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelNameVAT": {
    "name": "invoicesCreateInvoiceLabelNameVAT",
    "characters": "VAT 25 %",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceVAT6": {
    "name": "invoicesCreateInvoiceVAT6",
    "characters": "6 %",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)",
          "opacity": 0.8
        }
      }
    }
  },
  "invoicesCreateInvoiceVAT12": {
    "name": "invoicesCreateInvoiceVAT12",
    "characters": "12 %",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceVAT25Selected": {
    "name": "invoicesCreateInvoiceVAT25Selected",
    "characters": "25 %",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceVATCustom": {
    "name": "invoicesCreateInvoiceVATCustom",
    "characters": "Custom",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelNameSubTotal": {
    "name": "invoicesCreateInvoiceLabelNameSubTotal",
    "characters": "Sub total",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelNameSubTotalValue": {
    "name": "invoicesCreateInvoiceLabelNameSubTotalValue",
    "characters": "780 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelNameVATValue": {
    "name": "invoicesCreateInvoiceLabelNameVATValue",
    "characters": "195 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelNameTotal": {
    "name": "invoicesCreateInvoiceLabelNameTotal",
    "characters": "Total",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceLabelNameTotalValue": {
    "name": "invoicesCreateInvoiceLabelNameTotalValue",
    "characters": "975 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoicesCreateInvoiceButtonCreateInvoice": {
    "name": "invoicesCreateInvoiceButtonCreateInvoice",
    "characters": "Create invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "hidden\nSubscription fee": {
    "name": "hidden\nSubscription fee",
    "characters": "For now only invoice type is\nSubscription fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "24px",
          "fontWeight": 500,
          "letterSpacing": "-0.5px",
          "lineHeight": "33.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "For now only payment method is": {
    "name": "For now only payment method is",
    "characters": "For now only payment method is ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "24px",
          "fontWeight": 500,
          "letterSpacing": "-0.5px",
          "lineHeight": "33.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "hidden\nOpens new dropdown input field for Custom \nVAT amount": {
    "name": "hidden\nOpens new dropdown input field for Custom \nVAT amount",
    "characters": "VAT Custom >\nOpens new dropdown input field for Custom \nVAT amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "24px",
          "fontWeight": 700,
          "letterSpacing": "-0.5px",
          "lineHeight": "33.6px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "createInvoiceHoverLabel": {
    "name": "createInvoiceHoverLabel",
    "characters": "Create invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "registerExternalPaymentHover": {
    "name": "registerExternalPaymentHover",
    "characters": "Register external payment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "subscriptionFeeBelowZeroErrorLabel": {
    "name": "subscriptionFeeBelowZeroErrorLabel",
    "characters": "Fee cannot be below 0",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "subscriptionFeeTypeErrorLabel": {
    "name": "subscriptionFeeTypeErrorLabel",
    "characters": "Invalid fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "subscriptionVatBelowZeroErrorLabel": {
    "name": "subscriptionVatBelowZeroErrorLabel",
    "characters": "Vat cannot be below 0",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "subscriptionVatTypeErrorLabel": {
    "name": "subscriptionVatTypeErrorLabel",
    "characters": "Invalid vat",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "areYourSureDeleteCustomerHeading": {
    "name": "areYourSureDeleteCustomerHeading",
    "characters": "Are you sure you want \nto delete customer?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "areYourSureDeleteCustomerText": {
    "name": "areYourSureDeleteCustomerText",
    "characters": "The customer can not be restored in the system",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "areYourSureCancelDeleteCustomerButton": {
    "name": "areYourSureCancelDeleteCustomerButton",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "areYourSureYesDeleteCustomerButton": {
    "name": "areYourSureYesDeleteCustomerButton",
    "characters": "Yes",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuTabBillingSettingsActive": {
    "name": "menuTabBillingSettingsActive",
    "characters": "Billing settings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "billingSettingsHeading": {
    "name": "billingSettingsHeading",
    "characters": "Billing settings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "registerInvoicePaymentHover": {
    "name": "registerInvoicePaymentHover",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsPricingPlanHeading": {
    "name": "billingSettingsPricingPlanHeading",
    "characters": "Pricing plan",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsPricingPlanSubscriptionPlan": {
    "name": "billingSettingsPricingPlanSubscriptionPlan",
    "characters": "Subscription plan",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsPricingPlanSubscriptionPlanEssential": {
    "name": "billingSettingsPricingPlanSubscriptionPlanEssential",
    "characters": "Essential",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsRecurringFeesHeading": {
    "name": "billingSettingsRecurringFeesHeading",
    "characters": "Recurring fees",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsRecurringFeesSubscriptionFee": {
    "name": "billingSettingsRecurringFeesSubscriptionFee",
    "characters": "Subscription fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsRecurringFeesSubscriptionFeeAmount": {
    "name": "billingSettingsRecurringFeesSubscriptionFeeAmount",
    "characters": "300",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsRecurringFeesSubscriptionFeeCurrenncy": {
    "name": "billingSettingsRecurringFeesSubscriptionFeeCurrenncy",
    "characters": "kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsNextBillingDate": {
    "name": "billingSettingsNextBillingDate",
    "characters": "Next billing date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsNextBillingDateValue": {
    "name": "billingSettingsNextBillingDateValue",
    "characters": "01 oct 2023",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsOtherFeesHeading": {
    "name": "billingSettingsOtherFeesHeading",
    "characters": "Other fees",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsOtherFeesFxSurcharge": {
    "name": "billingSettingsOtherFeesFxSurcharge",
    "characters": "FX Surcharge",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsOtherFeesFxSurchargeValueOption1": {
    "name": "billingSettingsOtherFeesFxSurchargeValueOption1",
    "characters": "0%",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsCashbackHeading": {
    "name": "billingSettingsCashbackHeading",
    "characters": "Cashback",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsCashbackCashback": {
    "name": "billingSettingsCashbackCashback",
    "characters": "Cashback %",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsCashbackCashbackValueOption1": {
    "name": "billingSettingsCashbackCashbackValueOption1",
    "characters": "0%",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsHoverResetSettings": {
    "name": "billingSettingsHoverResetSettings",
    "characters": "Reset to default",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsHoverInfoValueEdited": {
    "name": "billingSettingsHoverInfoValueEdited",
    "characters": "This value is edited from default value XXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsHoverResetAllSettings": {
    "name": "billingSettingsHoverResetAllSettings",
    "characters": "Reset all settings to default",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "Billing settings - Default": {
    "name": "Billing settings - Default",
    "characters": "Billing settings - Default",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-2px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "Billing settings - Changed values": {
    "name": "Billing settings - Changed values",
    "characters": "Billing settings - Changed values",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "100px",
          "fontWeight": 700,
          "letterSpacing": "-2px",
          "lineHeight": "120px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "billingSettingsModalHeadingAreYouSure": {
    "name": "billingSettingsModalHeadingAreYouSure",
    "characters": "Are you sure?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsModalTextResetAllValues": {
    "name": "billingSettingsModalTextResetAllValues",
    "characters": "You are about to remove all overrides. Pricing plan default settings will apply.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsModalButtonResetAllCancel": {
    "name": "billingSettingsModalButtonResetAllCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsModalButtonResetAllYes": {
    "name": "billingSettingsModalButtonResetAllYes",
    "characters": "Yes, proceed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsModalTextBeta": {
    "name": "billingSettingsModalTextBeta",
    "characters": "This is a beta feature, are you sure what you are doing?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsModalTextResetSubscriptionFee": {
    "name": "billingSettingsModalTextResetSubscriptionFee",
    "characters": "You are about to remove this override. Pricing plan default setting will apply.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsModalButtonResetSubscriptionFeeCancel": {
    "name": "billingSettingsModalButtonResetSubscriptionFeeCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsModalButtonResetSubscriptionFeeYes": {
    "name": "billingSettingsModalButtonResetSubscriptionFeeYes",
    "characters": "Yes, proceed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "billingSettingsPricingPlanSubscriptionPlanPremium": {
    "name": "billingSettingsPricingPlanSubscriptionPlanPremium",
    "characters": "Premium",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsOtherFeesFxSurchargeValueOption2": {
    "name": "billingSettingsOtherFeesFxSurchargeValueOption2",
    "characters": "1.5%",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsOtherFeesFxSurchargeValueOption3": {
    "name": "billingSettingsOtherFeesFxSurchargeValueOption3",
    "characters": "1.95%",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsCashbackCashbackValueOption2": {
    "name": "billingSettingsCashbackCashbackValueOption2",
    "characters": "0.5%",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "billingSettingsCashbackCashbackValueOption3": {
    "name": "billingSettingsCashbackCashbackValueOption3",
    "characters": "1%",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersDirectDebitHeading": {
    "name": "customersDirectDebitHeading",
    "characters": "Direct debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersDirectDebitNewDirectDebitConHeading": {
    "name": "customersDirectDebitNewDirectDebitConHeading",
    "characters": "New direct debit connection",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersDirectDebitNewDirectDebitConText": {
    "name": "customersDirectDebitNewDirectDebitConText",
    "characters": "Set the customers bank account number for direct debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersDirectDebitNewDirectDebitConFieldLabel": {
    "name": "customersDirectDebitNewDirectDebitConFieldLabel",
    "characters": "Bank account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersDirectDebitNewDirectDebitCheckSendMandateAgreement": {
    "name": "customersDirectDebitNewDirectDebitCheckSendMandateAgreement",
    "characters": "Send mandate agreement to customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersDirectDebitNewDirectDebitButtonSend": {
    "name": "customersDirectDebitNewDirectDebitButtonSend",
    "characters": "Send",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersDirectDebitMandateAgreementsHeading": {
    "name": "customersDirectDebitMandateAgreementsHeading",
    "characters": "Mandate agreements",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersDirectDebitDetailsHeading": {
    "name": "customersDirectDebitDetailsHeading",
    "characters": "Direct debit details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitTagPendingCancellation": {
    "name": "directDebitTagPendingCancellation",
    "characters": "Pending Cancellation",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "2023-01-03, 22:30": {
    "name": "2023-01-03, 22:30",
    "characters": "2023-01-03, 22:30",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "ATLAR": {
    "name": "ATLAR",
    "characters": "ATLAR",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "enterBankAccountHeadingIBAN": {
    "name": "enterBankAccountHeadingIBAN",
    "characters": "Add IBAN account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "20px",
          "fontWeight": 700,
          "letterSpacing": "-0.6px",
          "lineHeight": "24px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsTextIBAN": {
    "name": "DirectDebitDetailsTextIBAN",
    "characters": "Set the customers IBAN account number for direct debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFenterBankAccountLabelIBAN": {
    "name": "mFenterBankAccountLabelIBAN",
    "characters": "IBAN account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "enterBankAccountButtonIBAN": {
    "name": "enterBankAccountButtonIBAN",
    "characters": "Set IBAN account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "areYourSureHeading": {
    "name": "areYourSureHeading",
    "characters": "Are you sure?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "areYourSureSendMandateAlertText": {
    "name": "areYourSureSendMandateAlertText",
    "characters": "You are about to set up direct debit without sending a mandate agreement. This is not recommended.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "areYourSureSendMandateAlertButtonCancel": {
    "name": "areYourSureSendMandateAlertButtonCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "areYourSureSendMandateAlertButtonYes": {
    "name": "areYourSureSendMandateAlertButtonYes",
    "characters": "Yes, proceed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customersDirectDebitDetailsHoverTooltipCancel": {
    "name": "customersDirectDebitDetailsHoverTooltipCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customersDirectDebitDetailsHoverTooltipRefresh": {
    "name": "customersDirectDebitDetailsHoverTooltipRefresh",
    "characters": "Refresh",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "15.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFenterIBANAccountError": {
    "name": "mFenterIBANAccountError",
    "characters": "Add IBAN account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "headerSignOut": {
    "name": "headerSignOut",
    "characters": "Sign out",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(104, 105, 107, 1)"
        }
      }
    }
  },
  "menuInboxDefault": {
    "name": "menuInboxDefault",
    "characters": "Inbox",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuLeadCheckDefault": {
    "name": "menuLeadCheckDefault",
    "characters": "Lead check",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuCustomersDefault": {
    "name": "menuCustomersDefault",
    "characters": "Customers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuCreditsDefault": {
    "name": "menuCreditsDefault",
    "characters": "Credits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuBiddingDefault": {
    "name": "menuBiddingDefault",
    "characters": "Bidding",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuAccountingDefault": {
    "name": "menuAccountingDefault",
    "characters": "Accounting",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "menuInboxActive": {
    "name": "menuInboxActive",
    "characters": "Inbox",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "menuLeadCheckActive": {
    "name": "menuLeadCheckActive",
    "characters": "Lead check",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "menuCustomersActive": {
    "name": "menuCustomersActive",
    "characters": "Customers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "menuCreditsActive": {
    "name": "menuCreditsActive",
    "characters": "Credits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "menuBiddingActive": {
    "name": "menuBiddingActive",
    "characters": "Bidding",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "menuAccountingActive": {
    "name": "menuAccountingActive",
    "characters": "Accounting",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "menuInboxHover": {
    "name": "menuInboxHover",
    "characters": "Inbox",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(17, 167, 104, 1)"
        }
      }
    }
  },
  "menuLeadCheckHover": {
    "name": "menuLeadCheckHover",
    "characters": "Lead check",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(17, 167, 104, 1)"
        }
      }
    }
  },
  "menuCustomersHover": {
    "name": "menuCustomersHover",
    "characters": "Customers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(17, 167, 104, 1)"
        }
      }
    }
  },
  "menuCreditsHover": {
    "name": "menuCreditsHover",
    "characters": "Credits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(17, 167, 104, 1)"
        }
      }
    }
  },
  "menuBiddingHover": {
    "name": "menuBiddingHover",
    "characters": "Bidding",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(17, 167, 104, 1)"
        }
      }
    }
  },
  "menuAccountingHover": {
    "name": "menuAccountingHover",
    "characters": "Accounting",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(17, 167, 104, 1)"
        }
      }
    }
  },
  "Typing|": {
    "name": "Typing|",
    "characters": "Typing|",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "year": {
    "name": "year",
    "characters": "Year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "month": {
    "name": "month",
    "characters": "Month",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "peReconGenerateAndSend": {
    "name": "peReconGenerateAndSend",
    "characters": "Generate & Send",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "15px",
          "fontWeight": 500,
          "lineHeight": "17.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "peReconcilliationTooltipText": {
    "name": "peReconcilliationTooltipText",
    "characters": "Generate a monthly reconcilation report for a year and month and send it to PE Accounting. This will enforce a new report regardless of whether there already is an existing report for the month. However, not that as of March 2021, PE accepts but discards any duplicates, so it is not (yet) possible to send a correcting report",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "12px",
          "fontWeight": 400,
          "lineHeight": "18px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "generatedAt": {
    "name": "generatedAt",
    "characters": "Generated at",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "peReconYear": {
    "name": "peReconYear",
    "characters": "Year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "peReconMonth": {
    "name": "peReconMonth",
    "characters": "Month",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "peReconCreateId": {
    "name": "peReconCreateId",
    "characters": "PE create_id",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "lineHeight": "16.4px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "peReconInfoHeader": {
    "name": "peReconInfoHeader",
    "characters": "Info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "26px",
          "fontWeight": 500,
          "letterSpacing": "-0.5px",
          "lineHeight": "36.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "peReconInfoText": {
    "name": "peReconInfoText",
    "characters": "Every month on the 4th at 23:00 we generate a monthly reconcilation report for every customer that has CardPartner=PE. The report is sent  to the PE system.\nThis view is for following up that reports were actually sent and in case a report failed it’s possible to trigger manually.\nNote that the system has a fallback on the 5th every month to catch any failures. System will not send duplicates.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUpHeading": {
    "name": "autoTopUpHeading",
    "characters": "Auto top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUpSetLimitLabel": {
    "name": "autoTopUpSetLimitLabel",
    "characters": "Set auto top-up limits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "mFautoTopUpFallsBelowLabel": {
    "name": "mFautoTopUpFallsBelowLabel",
    "characters": "When balance falls below",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFautoTopUpToLabel": {
    "name": "mFautoTopUpToLabel",
    "characters": "Top up with the following amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "autoTopUpSetLimitButton": {
    "name": "autoTopUpSetLimitButton",
    "characters": "Set limits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "autoTopUpDetails": {
    "name": "autoTopUpDetails",
    "characters": "Auto top-up details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 800,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUpStatus": {
    "name": "autoTopUpStatus",
    "characters": "Pending",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUp": {
    "name": "autoTopUp",
    "characters": "Auto top-up status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "autoTopUpDirectDebitApprovedStatus": {
    "name": "autoTopUpDirectDebitApprovedStatus",
    "characters": "Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUpDirectDebitApproved": {
    "name": "autoTopUpDirectDebitApproved",
    "characters": "Direct debit status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "autoTopUpCustomerSetDetailsStatus": {
    "name": "autoTopUpCustomerSetDetailsStatus",
    "characters": "Inactive",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUpCustomerSetDetails": {
    "name": "autoTopUpCustomerSetDetails",
    "characters": "Auto top-up status set by customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsBankAccountValue": {
    "name": "DirectDebitDetailsBankAccountValue",
    "characters": "8732 40489238",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "autoTopUpDetailsBankAccount": {
    "name": "autoTopUpDetailsBankAccount",
    "characters": "Bank account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "autoTopupHeading": {
    "name": "autoTopupHeading",
    "characters": "Autotopup",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "lowBalanceAlertHeading": {
    "name": "lowBalanceAlertHeading",
    "characters": "Low balance alert",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "lowBalanceAlertSetLabel": {
    "name": "lowBalanceAlertSetLabel",
    "characters": "Set low balance alert limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "mFlowBalanceAlertSetLabel": {
    "name": "mFlowBalanceAlertSetLabel",
    "characters": "When balance falls below",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "lowBalanceAlertSetButton": {
    "name": "lowBalanceAlertSetButton",
    "characters": "Set",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "accountMenuAutoTopUp": {
    "name": "accountMenuAutoTopUp",
    "characters": "Auto top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "18px",
          "fontWeight": 800,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountMenuLowBalanceAlert": {
    "name": "accountMenuLowBalanceAlert",
    "characters": "Low balance alert",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "18px",
          "fontWeight": 800,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "lowBalanceAlertDetails": {
    "name": "lowBalanceAlertDetails",
    "characters": "Low balance alert details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 800,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "lowBalanceAlertText": {
    "name": "lowBalanceAlertText",
    "characters": "Low balance alert status set by customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "lowBalanceAlertStatus": {
    "name": "lowBalanceAlertStatus",
    "characters": "Active",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitHeading": {
    "name": "directDebitHeading",
    "characters": "Direct debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsStateValue": {
    "name": "DirectDebitDetailsStateValue",
    "characters": "Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsBankAccount": {
    "name": "DirectDebitDetailsBankAccount",
    "characters": "Bank account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsState": {
    "name": "DirectDebitDetailsState",
    "characters": "Status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsModifiedAtValue": {
    "name": "DirectDebitDetailsModifiedAtValue",
    "characters": "2021-03-01, 12:30",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsModifiedAt": {
    "name": "DirectDebitDetailsModifiedAt",
    "characters": "Modifed at",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsHeading": {
    "name": "DirectDebitDetailsHeading",
    "characters": "Direct debit details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 800,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "enterBankAccountHeading": {
    "name": "enterBankAccountHeading",
    "characters": "Add bank account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "20px",
          "fontWeight": 700,
          "letterSpacing": "-0.6px",
          "lineHeight": "24px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "mFenterBankAccountLabel": {
    "name": "mFenterBankAccountLabel",
    "characters": "Bank account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsText": {
    "name": "DirectDebitDetailsText",
    "characters": "Set the customers bank account number for direct debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "enterBankAccountButton": {
    "name": "enterBankAccountButton",
    "characters": "Set bank account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "backOfficeMenuCreditOnCard": {
    "name": "backOfficeMenuCreditOnCard",
    "characters": "Credit on card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "18px",
          "fontWeight": 800,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "backOfficeMenuInvoices": {
    "name": "backOfficeMenuInvoices",
    "characters": "Invoices",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "paymentsHeading": {
    "name": "paymentsHeading",
    "characters": "Billing overview",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 800,
          "letterSpacing": "-0.3px",
          "lineHeight": "16px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentsDay": {
    "name": "paymentsDay",
    "characters": "Invoice date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentPlanPaymentsDate1": {
    "name": "paymentPlanPaymentsDate1",
    "characters": "2021-04-03",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentPlanPaymentsDate2": {
    "name": "paymentPlanPaymentsDate2",
    "characters": "2021-03-03",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentPlanPaymentsDate3": {
    "name": "paymentPlanPaymentsDate3",
    "characters": "2021-02-03",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentsAmount": {
    "name": "paymentsAmount",
    "characters": "Payment amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentsAmountNum": {
    "name": "paymentsAmountNum",
    "characters": "15 241 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentsRepayment": {
    "name": "paymentsRepayment",
    "characters": "Credit repayment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentsRepaymentNum": {
    "name": "paymentsRepaymentNum",
    "characters": "12 038 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentsInterest": {
    "name": "paymentsInterest",
    "characters": "Interest",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentsInterestNum": {
    "name": "paymentsInterestNum",
    "characters": "3 203 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentsStatus": {
    "name": "paymentsStatus",
    "characters": "Status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentPlanPaymentsStatus1": {
    "name": "paymentPlanPaymentsStatus1",
    "characters": "Scheduled",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "paymentPlanPaymentsStatus2": {
    "name": "paymentPlanPaymentsStatus2",
    "characters": "Paid",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentsInvoicePDF": {
    "name": "paymentsInvoicePDF",
    "characters": "PDF",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paymentsInvoicePDFDownload": {
    "name": "paymentsInvoicePDFDownload",
    "characters": "Invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "paymentsAction": {
    "name": "paymentsAction",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "Book": {
    "name": "Book",
    "characters": "Book",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Settle": {
    "name": "Settle",
    "characters": "Settle",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Cancel": {
    "name": "Cancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "oneTimeDirectDebitButton": {
    "name": "oneTimeDirectDebitButton",
    "characters": "One-time direct debit top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "noDirectDebitActiveHeading": {
    "name": "noDirectDebitActiveHeading",
    "characters": "Not possible to top-up the customers account right now because direct debit is not active.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "topUpAmountHeading": {
    "name": "topUpAmountHeading",
    "characters": "How much to top-up?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "topUpAmountButton": {
    "name": "topUpAmountButton",
    "characters": "Top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "18px",
          "fontWeight": 800,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "mFtopUpAmountLabel": {
    "name": "mFtopUpAmountLabel",
    "characters": "Top-up amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "JSONData": {
    "name": "JSONData",
    "characters": "JSON data",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setCreditLimit": {
    "name": "setCreditLimit",
    "characters": "Set max credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFsetCreditLimitLabel": {
    "name": "mFsetCreditLimitLabel",
    "characters": "Credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setCreditLimitButton": {
    "name": "setCreditLimitButton",
    "characters": "Set credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditRequestButton": {
    "name": "creditRequestButton",
    "characters": "Clear request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setCreditState": {
    "name": "setCreditState",
    "characters": "Set credit state",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditStateApproved": {
    "name": "creditStateApproved",
    "characters": "Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "CreditDetailsCreditLimitNum": {
    "name": "CreditDetailsCreditLimitNum",
    "characters": "50 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "CreditDetailsCreditUsedNum": {
    "name": "CreditDetailsCreditUsedNum",
    "characters": "23 549 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "CreditDetailsCreditLimit": {
    "name": "CreditDetailsCreditLimit",
    "characters": "Max credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "CreditDetailsCreditUsed": {
    "name": "CreditDetailsCreditUsed",
    "characters": "Credit used",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "CreditDetailsCreditLeftNum": {
    "name": "CreditDetailsCreditLeftNum",
    "characters": "26 451 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "CreditDetailsCreditLeft": {
    "name": "CreditDetailsCreditLeft",
    "characters": "Credit available",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "CreditDetailsHeading": {
    "name": "CreditDetailsHeading",
    "characters": "Credit details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditRequestText": {
    "name": "creditRequestText",
    "characters": "BlablaldkgdkfjdskfjdsfdBlablaldkgdkfjdskfjdsfdBlablaldkgdkfjdskfjdsfd",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "dragAndDropFilesHeading": {
    "name": "dragAndDropFilesHeading",
    "characters": "Upload files",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "18px",
          "fontWeight": 800,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "dragAndDropFilesText": {
    "name": "dragAndDropFilesText",
    "characters": "Drag and Drop files here or",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "dragAndDropFilesLink": {
    "name": "dragAndDropFilesLink",
    "characters": "choose file",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "textDecoration": "UNDERLINE",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "accountSettingsAutoTopUpStatusPaused": {
    "name": "accountSettingsAutoTopUpStatusPaused",
    "characters": "Paused",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountSettingsAutoTopUpStatusRequested": {
    "name": "accountSettingsAutoTopUpStatusRequested",
    "characters": "Requested",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountSettingsAutoTopUpStatusActive": {
    "name": "accountSettingsAutoTopUpStatusActive",
    "characters": "Active",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "AutoTopUpDetailsStatusValuePending": {
    "name": "AutoTopUpDetailsStatusValuePending",
    "characters": "Pending",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountSettingsAutoTopUpStatusError": {
    "name": "accountSettingsAutoTopUpStatusError",
    "characters": "Error",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountSettingsAutoTopUpStatusInactive": {
    "name": "accountSettingsAutoTopUpStatusInactive",
    "characters": "Inactive",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditStateDenied": {
    "name": "creditStateDenied",
    "characters": "Denied",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditStateInactive": {
    "name": "creditStateInactive",
    "characters": "Inactive",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFsetCreditLimitError": {
    "name": "mFsetCreditLimitError",
    "characters": "Add positive number less than 1 million",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceInfoInvoiceDateValueError": {
    "name": "invoiceInfoInvoiceDateValueError",
    "characters": "Please add a invoice date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFEnterInSEKError": {
    "name": "mFEnterInSEKError",
    "characters": "Please add the amount in SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceInfoDueDateValueError": {
    "name": "invoiceInfoDueDateValueError",
    "characters": "Please add a invoice date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceDetailsCreditNumberError": {
    "name": "mFinvoiceDetailsCreditNumberError",
    "characters": "Please enter credit number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceDetailsCustomerError": {
    "name": "mFinvoiceDetailsCustomerError",
    "characters": "Please enter customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoCurrencyError": {
    "name": "mFinvoiceInfoCurrencyError",
    "characters": "Please choose currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoPaymentMethodError": {
    "name": "mFinvoiceInfoPaymentMethodError",
    "characters": "Please choose payment method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoInvoiceDateError": {
    "name": "mFinvoiceInfoInvoiceDateError",
    "characters": "Please choose a invocie date on format YYYY-MM-DD",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoDueDateError": {
    "name": "mFinvoiceInfoDueDateError",
    "characters": "Please choose a due date on format YYYY-MM-DD",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoDueDateAfterInvoiceDateError": {
    "name": "mFinvoiceInfoDueDateAfterInvoiceDateError",
    "characters": "The due date has to be after the invoice date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFautoTopUpFallsBelowError": {
    "name": "mFautoTopUpFallsBelowError",
    "characters": "Add positive number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFautoTopUpToError": {
    "name": "mFautoTopUpToError",
    "characters": "Add positive number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFlowBalanceAlertSetError": {
    "name": "mFlowBalanceAlertSetError",
    "characters": "Please enter the amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFtopUpAmountError": {
    "name": "mFtopUpAmountError",
    "characters": "Choose your top-up amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFreminderInvoiceError": {
    "name": "mFreminderInvoiceError",
    "characters": "Please enter the penalty fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createInvoiceButton": {
    "name": "createInvoiceButton",
    "characters": "Create  invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsHeading": {
    "name": "creditSettingsHeading",
    "characters": "Credit settings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "C": {
    "name": "C",
    "characters": "C",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "10px",
          "fontWeight": 800,
          "letterSpacing": "-0.2px",
          "lineHeight": "14px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "DC": {
    "name": "DC",
    "characters": "DC",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "10px",
          "fontWeight": 800,
          "letterSpacing": "-0.2px",
          "lineHeight": "14px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoHeading": {
    "name": "invoiceInfoHeading",
    "characters": "Invoice information",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoSettled": {
    "name": "invoiceInfoSettled",
    "characters": "Settled",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecHeading": {
    "name": "invoiceSpecHeading",
    "characters": "Specification",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsAmortization": {
    "name": "invoiceSpecItemDetailsAmortization",
    "characters": "Amortization",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsAmortizationNum": {
    "name": "invoiceSpecItemDetailsAmortizationNum",
    "characters": "3 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsInterest": {
    "name": "invoiceSpecItemDetailsInterest",
    "characters": "Interest",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsInterestNum": {
    "name": "invoiceSpecItemDetailsInterestNum",
    "characters": "1 500 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsPenaltyFee": {
    "name": "invoiceSpecItemDetailsPenaltyFee",
    "characters": "Penalty fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsPenaltyFeeNum": {
    "name": "invoiceSpecItemDetailsPenaltyFeeNum",
    "characters": "1 500 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsInvoiceFee": {
    "name": "invoiceSpecItemDetailsInvoiceFee",
    "characters": "Invoice fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsInvoiceFeeNum": {
    "name": "invoiceSpecItemDetailsInvoiceFeeNum",
    "characters": "1 500 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsTotalSubTotalNum": {
    "name": "invoiceSpecItemDetailsTotalSubTotalNum",
    "characters": "7 500 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsTotalSubTotal": {
    "name": "invoiceSpecItemDetailsTotalSubTotal",
    "characters": "Sub total",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsTotalVATAmountNum": {
    "name": "invoiceSpecItemDetailsTotalVATAmountNum",
    "characters": "450 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsTotalVATAmount": {
    "name": "invoiceSpecItemDetailsTotalVATAmount",
    "characters": "VAT amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsTotalNum": {
    "name": "invoiceSpecItemDetailsTotalNum",
    "characters": "7 950 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetailsTotal": {
    "name": "invoiceSpecItemDetailsTotal",
    "characters": "Total",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoRemainingAmountValue": {
    "name": "invoiceInfoRemainingAmountValue",
    "characters": "1 225 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoPaidAmount": {
    "name": "invoiceInfoPaidAmount",
    "characters": "Paid amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoRemainingAmount": {
    "name": "invoiceInfoRemainingAmount",
    "characters": "Remaining",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoLink": {
    "name": "invoiceInfoLink",
    "characters": "Generate PDF",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "accountingVouchersHeading": {
    "name": "accountingVouchersHeading",
    "characters": "Vouchers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingVouchersBooking": {
    "name": "accountingVouchersBooking",
    "characters": "Bookings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingVouchersBookingLink": {
    "name": "accountingVouchersBookingLink",
    "characters": "RI 124 \nC 234",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "accountingVouchersPayment": {
    "name": "accountingVouchersPayment",
    "characters": "Payments",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingVouchersPaymentLink": {
    "name": "accountingVouchersPaymentLink",
    "characters": "P 456 \nP 789 \nP 648",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "invoiceTooltip": {
    "name": "invoiceTooltip",
    "characters": "Invoice - 2021-02-23",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "invoiceInfo": {
    "name": "invoiceInfo",
    "characters": "Invoice number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoValue": {
    "name": "invoiceInfoValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoOCR": {
    "name": "invoiceInfoOCR",
    "characters": "OCR",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoOCRValue": {
    "name": "invoiceInfoOCRValue",
    "characters": "16606675",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoCustomer": {
    "name": "invoiceInfoCustomer",
    "characters": "Customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoCustomerValue": {
    "name": "invoiceInfoCustomerValue",
    "characters": "Peter Nilsson EF",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoType": {
    "name": "invoiceInfoType",
    "characters": "Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoTypeValue": {
    "name": "invoiceInfoTypeValue",
    "characters": "RepaymentInvoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoBookedDate": {
    "name": "invoiceInfoBookedDate",
    "characters": "Booked date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoBookedDateValue": {
    "name": "invoiceInfoBookedDateValue",
    "characters": "2021-04-28",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoInvoiceDate": {
    "name": "invoiceInfoInvoiceDate",
    "characters": "Invoice date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoInvoiceDateValue": {
    "name": "invoiceInfoInvoiceDateValue",
    "characters": "2021-05-01",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoDueDate": {
    "name": "invoiceInfoDueDate",
    "characters": "Due date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoDueDateValue": {
    "name": "invoiceInfoDueDateValue",
    "characters": "2021-05-08",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoReminderDate": {
    "name": "invoiceInfoReminderDate",
    "characters": "Reminder date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoReminderDateValue": {
    "name": "invoiceInfoReminderDateValue",
    "characters": "2021-05-10",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoReminderDueDate": {
    "name": "invoiceInfoReminderDueDate",
    "characters": "Reminder due date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoReminderDateDueValue": {
    "name": "invoiceInfoReminderDateDueValue",
    "characters": "2021-05-17",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoSettledDate": {
    "name": "invoiceInfoSettledDate",
    "characters": "Settled date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoSettledDateValue": {
    "name": "invoiceInfoSettledDateValue",
    "characters": "2021-05-17",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceHistoryHeading": {
    "name": "invoiceHistoryHeading",
    "characters": "Invoice history",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceHistoryString": {
    "name": "invoiceHistoryString",
    "characters": "BOOKED 2021-04-26, REMINDED 2021-05-10, DEBT_COLLECTION 2021-05-20, SETTLED 2021-05-30",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "repaymentInvoicesHeading": {
    "name": "repaymentInvoicesHeading",
    "characters": "Repayment invoices",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoBooked": {
    "name": "invoiceInfoBooked",
    "characters": "Booked",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoDraft": {
    "name": "invoiceInfoDraft",
    "characters": "Draft",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoOverdue": {
    "name": "invoiceInfoOverdue",
    "characters": "Overdue",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoDebtCollection": {
    "name": "invoiceInfoDebtCollection",
    "characters": "Debt collection",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoReminder": {
    "name": "invoiceInfoReminder",
    "characters": "Reminder",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoCancelled": {
    "name": "invoiceInfoCancelled",
    "characters": "Cancelled",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceInfoCredited": {
    "name": "invoiceInfoCredited",
    "characters": "Credited",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createInvoiceHeading": {
    "name": "createInvoiceHeading",
    "characters": "Create invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceDetailsCreditNumber": {
    "name": "invoiceDetailsCreditNumber",
    "characters": "Credit number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFinvoiceDetailsCreditNumberLabel": {
    "name": "mFinvoiceDetailsCreditNumberLabel",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceDetailsCustomer": {
    "name": "invoiceDetailsCustomer",
    "characters": "Customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFinvoiceDetailsCustomerLabel": {
    "name": "mFinvoiceDetailsCustomerLabel",
    "characters": "Peter Nilsson EF",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoInvoiceDateLabel": {
    "name": "mFinvoiceInfoInvoiceDateLabel",
    "characters": "Invoice date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoDueDateLabel": {
    "name": "mFinvoiceInfoDueDateLabel",
    "characters": "Due date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceInfoCurrency": {
    "name": "invoiceInfoCurrency",
    "characters": "Currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoPaymentMethod": {
    "name": "invoiceInfoPaymentMethod",
    "characters": "Payment method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFinvoiceInfoPaymentMethodLabel": {
    "name": "mFinvoiceInfoPaymentMethodLabel",
    "characters": "Direct debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceSpecificationHeading": {
    "name": "invoiceSpecificationHeading",
    "characters": "Invoice specification",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSpecItemDetails": {
    "name": "invoiceSpecItemDetails",
    "characters": "Item details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceSpecAmount": {
    "name": "invoiceSpecAmount",
    "characters": "Amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFEnterInSEKLabel": {
    "name": "mFEnterInSEKLabel",
    "characters": "Enter in SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "draftInvoiceButton": {
    "name": "draftInvoiceButton",
    "characters": "Draft  invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "reminderInvoiceHeading": {
    "name": "reminderInvoiceHeading",
    "characters": "Send reminder invoice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "reminderInvoiceButtonSend": {
    "name": "reminderInvoiceButtonSend",
    "characters": "Send",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "mFreminderInvoiceLabel": {
    "name": "mFreminderInvoiceLabel",
    "characters": "Penalty fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "reminderInvoiceTopLabel": {
    "name": "reminderInvoiceTopLabel",
    "characters": "Set penalty fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "invoiceInfoTypeValueRepaymentInvoiceTableRow": {
    "name": "invoiceInfoTypeValueRepaymentInvoiceTableRow",
    "characters": "RI",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceInfoTypeValueRequestForPaymentTableRow": {
    "name": "invoiceInfoTypeValueRequestForPaymentTableRow",
    "characters": "RFP",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceDebtCollectionDate": {
    "name": "invoiceDebtCollectionDate",
    "characters": "Debt collection date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceDebtCollectionDateValue": {
    "name": "invoiceDebtCollectionDateValue",
    "characters": "2021-05-27",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSettledDate": {
    "name": "invoiceSettledDate",
    "characters": "Settled date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "invoiceSettledDateValue": {
    "name": "invoiceSettledDateValue",
    "characters": "2021-05-27",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "featuresToggleDropDownButton": {
    "name": "featuresToggleDropDownButton",
    "characters": "Features",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "15px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "21px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "featuresToggleOrderCard": {
    "name": "featuresToggleOrderCard",
    "characters": "Order card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "13px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "18.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "featuresToggleReclaimCredits": {
    "name": "featuresToggleReclaimCredits",
    "characters": "Reclaim credits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "13px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "18.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "featuresToggleMakeTopUps": {
    "name": "featuresToggleMakeTopUps",
    "characters": "Make top-ups",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "13px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "18.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "featuresToggleKYCLoop": {
    "name": "featuresToggleKYCLoop",
    "characters": "KYC loop",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "13px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "18.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "tooltipDeleteCustomer": {
    "name": "tooltipDeleteCustomer",
    "characters": "Delete customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "13px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "18.2px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingInvoicesInvoices": {
    "name": "accountingInvoicesInvoices",
    "characters": "Invoice #",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesInvoiceValue": {
    "name": "invoicesInvoiceValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "accountingInvoicesState": {
    "name": "accountingInvoicesState",
    "characters": "State",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesStateValue": {
    "name": "invoicesStateValue",
    "characters": "Booked",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesInvoiceDate": {
    "name": "accountingInvoicesInvoiceDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesInvoiceDateValue": {
    "name": "invoicesInvoiceDateValue",
    "characters": "2021-04-03",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesDueDate": {
    "name": "accountingInvoicesDueDate",
    "characters": "Due date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesDueDateValue": {
    "name": "invoicesDueDateValue",
    "characters": "2021-04-03",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesType": {
    "name": "accountingInvoicesType",
    "characters": "Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingInvoicesCustomer": {
    "name": "accountingInvoicesCustomer",
    "characters": "Customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesCustomerValue": {
    "name": "invoicesCustomerValue",
    "characters": "Peter Nilsson AB",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesInvoiceAmount": {
    "name": "accountingInvoicesInvoiceAmount",
    "characters": "Invoice amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesInvoiceAmountValue": {
    "name": "invoicesInvoiceAmountValue",
    "characters": "15 241 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesRemaining": {
    "name": "accountingInvoicesRemaining",
    "characters": "Remaining ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesRemainingValue": {
    "name": "invoicesRemainingValue",
    "characters": "12 038 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesAction": {
    "name": "accountingInvoicesAction",
    "characters": "Action",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceExternalReference": {
    "name": "invoiceExternalReference",
    "characters": "External Reference",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceExternalReferenceValue": {
    "name": "invoiceExternalReferenceValue",
    "characters": "5144344722",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoicesHeading": {
    "name": "invoicesHeading",
    "characters": "Invoices",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesToolTipBook": {
    "name": "accountingInvoicesToolTipBook",
    "characters": "Book",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingInvoicesToolTipCancel": {
    "name": "accountingInvoicesToolTipCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingInvoicesToolTipCredit": {
    "name": "accountingInvoicesToolTipCredit",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingInvoicesToolTipRemind": {
    "name": "accountingInvoicesToolTipRemind",
    "characters": "Remind",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingInvoicesToolTipDebtCollection": {
    "name": "accountingInvoicesToolTipDebtCollection",
    "characters": "Debt collection",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "registerExternalPaymentButton": {
    "name": "registerExternalPaymentButton",
    "characters": "Register external payment\n",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "registerPaymentHeading": {
    "name": "registerPaymentHeading",
    "characters": "Register payment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "registerPaymentCustomerID": {
    "name": "registerPaymentCustomerID",
    "characters": "Customer ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentCustomerIDrLabel": {
    "name": "mFRegisterPaymentCustomerIDrLabel",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "registerPaymentOCR": {
    "name": "registerPaymentOCR",
    "characters": "OCR",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentOCRLabel": {
    "name": "mFRegisterPaymentOCRLabel",
    "characters": "OCR number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "registerPaymentAmount": {
    "name": "registerPaymentAmount",
    "characters": "Amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentAmountLabel": {
    "name": "mFRegisterPaymentAmountLabel",
    "characters": "Enter in SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "registerPaymentDate": {
    "name": "registerPaymentDate",
    "characters": "Payment date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentDateLabel": {
    "name": "mFRegisterPaymentDateLabel",
    "characters": "Today’s date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "registerPaymentDecription": {
    "name": "registerPaymentDecription",
    "characters": "Decription",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentDecriptionLabel": {
    "name": "mFRegisterPaymentDecriptionLabel",
    "characters": "Info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "registerPaymentButton": {
    "name": "registerPaymentButton",
    "characters": "Register payment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentCustomerIDrError": {
    "name": "mFRegisterPaymentCustomerIDrError",
    "characters": "Customer ID is required field",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentCustomerIDOrOCRError": {
    "name": "mFRegisterPaymentCustomerIDOrOCRError",
    "characters": "Please provide a customer ID or OCR number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentAmountError": {
    "name": "mFRegisterPaymentAmountError",
    "characters": "Payment amount is required field",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentDateError": {
    "name": "mFRegisterPaymentDateError",
    "characters": "Payment date is required field",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentDecriptionError": {
    "name": "mFRegisterPaymentDecriptionError",
    "characters": "Payment description is required field",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFRegisterPaymentAmountTypeError": {
    "name": "mFRegisterPaymentAmountTypeError",
    "characters": "Amount must be a number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardChoosePersonError": {
    "name": "mFOrderCardChoosePersonError",
    "characters": "Please choose a person",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardFullNameError": {
    "name": "mFOrderCardFullNameError",
    "characters": "Please enter the full name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardCompanyError": {
    "name": "mFOrderCardCompanyError",
    "characters": "Please enter the company name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardAddressError": {
    "name": "mFOrderCardAddressError",
    "characters": "Please enter the address",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardZipError": {
    "name": "mFOrderCardZipError",
    "characters": "Please enter the postal code",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardCityError": {
    "name": "mFOrderCardCityError",
    "characters": "Please enter the city",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "orderNewCardButton": {
    "name": "orderNewCardButton",
    "characters": "Order new card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "PlasticCardTableHeading": {
    "name": "PlasticCardTableHeading",
    "characters": "Activate card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "activateCardTokenHeader": {
    "name": "activateCardTokenHeader",
    "characters": "Token code:",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activateCardTokenCode": {
    "name": "activateCardTokenCode",
    "characters": "CSRR45",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activateCardTokenText": {
    "name": "activateCardTokenText",
    "characters": "Before activating the card, have you verified the \ntoken with the customer? (don’t reveal it yourself)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activateCardYes": {
    "name": "activateCardYes",
    "characters": "Yes, activate card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "activateCardCancel": {
    "name": "activateCardCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "orderNewCardModalHeading": {
    "name": "orderNewCardModalHeading",
    "characters": "Order card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "32px",
          "fontWeight": 700,
          "letterSpacing": "-1px",
          "lineHeight": "35.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "orderNewCardModalPersonHeading": {
    "name": "orderNewCardModalPersonHeading",
    "characters": "Choose for which person",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFOrderCardChoosePersonLabel": {
    "name": "mFOrderCardChoosePersonLabel",
    "characters": "Choose person",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "orderNewCardModalAddressHeading": {
    "name": "orderNewCardModalAddressHeading",
    "characters": "Confirm or change the cards delivery info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFOrderCardFullNameLabel": {
    "name": "mFOrderCardFullNameLabel",
    "characters": "Full name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFOrderCardCompanyLabel": {
    "name": "mFOrderCardCompanyLabel",
    "characters": "Company name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFOrderCardAddressLabel": {
    "name": "mFOrderCardAddressLabel",
    "characters": "Address",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFInvoiceRecipientOrgLabel": {
    "name": "mFInvoiceRecipientOrgLabel",
    "characters": "Apt, etc. (optional)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFOrderCardZipLabel": {
    "name": "mFOrderCardZipLabel",
    "characters": "Postal code",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "mFOrderCardCityLabel": {
    "name": "mFOrderCardCityLabel",
    "characters": "City",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "orderCardButton": {
    "name": "orderCardButton",
    "characters": "Order card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardStatusLabel": {
    "name": "cardStatusLabel",
    "characters": "Card status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "cardStatusLabelActive": {
    "name": "cardStatusLabelActive",
    "characters": "Active (CARD_OK)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "cardStatusLabelFrozen": {
    "name": "cardStatusLabelFrozen",
    "characters": "Frozen (CARD_BLOCKED)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "cardStatusLabelBlocked": {
    "name": "cardStatusLabelBlocked",
    "characters": "Blocked (SUSPECTED_FRAUD)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "cardStatusLabelTerminated": {
    "name": "cardStatusLabelTerminated",
    "characters": "Terminated (CARD_CLOSED)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customerTableLableName": {
    "name": "customerTableLableName",
    "characters": "Name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customerTableLableNameValue": {
    "name": "customerTableLableNameValue",
    "characters": "Johan Obermayer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customerTableLableSSN": {
    "name": "customerTableLableSSN",
    "characters": "SSN",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customerTableLableSSNValue": {
    "name": "customerTableLableSSNValue",
    "characters": "19790904-0177",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customerTableLableEmail": {
    "name": "customerTableLableEmail",
    "characters": "Email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customerTableLableEmailValue": {
    "name": "customerTableLableEmailValue",
    "characters": "jakob@mynt.se",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customerTableLablePhoneNumber": {
    "name": "customerTableLablePhoneNumber",
    "characters": "Phone number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "customerTableLablePhoneNumberValue": {
    "name": "customerTableLablePhoneNumberValue",
    "characters": "+46735083074",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customerTableLableRoles": {
    "name": "customerTableLableRoles",
    "characters": "Roles",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "peopleChipAdmin": {
    "name": "peopleChipAdmin",
    "characters": "ADMIN",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Roboto",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "0.3px",
          "lineHeight": "20px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "customerTableLableActions": {
    "name": "customerTableLableActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "deletedPeopleHeading": {
    "name": "deletedPeopleHeading",
    "characters": "Deleted people",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "24.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "peopleHeading": {
    "name": "peopleHeading",
    "characters": "People",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "24.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "addPersonButton": {
    "name": "addPersonButton",
    "characters": "Add person",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureHeading": {
    "name": "toolTipAreYouSureHeading",
    "characters": "Are you sure?",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureCancel": {
    "name": "toolTipAreYouSureCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureYes": {
    "name": "toolTipAreYouSureYes",
    "characters": "Yes",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "companyNameHeading": {
    "name": "companyNameHeading",
    "characters": "Accounting",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "infoStatusProducts": {
    "name": "infoStatusProducts",
    "characters": "Products",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "infoStatusKYC": {
    "name": "infoStatusKYC",
    "characters": "KYC",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "infoStatusCardFeatures": {
    "name": "infoStatusCardFeatures",
    "characters": "Card features",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "infoStatusCardActivationStatus": {
    "name": "infoStatusCardActivationStatus",
    "characters": "Card activation status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editPersonTooltip": {
    "name": "editPersonTooltip",
    "characters": "Edit person",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "sendEmailTooltip": {
    "name": "sendEmailTooltip",
    "characters": "Send email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "sendSMSTooltip": {
    "name": "sendSMSTooltip",
    "characters": "Send SMS",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "removeUserTooltip": {
    "name": "removeUserTooltip",
    "characters": "Remove user",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "sendInviteTooltip": {
    "name": "sendInviteTooltip",
    "characters": "Send invite email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "loginAsUserTooltip": {
    "name": "loginAsUserTooltip",
    "characters": "Login as user",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "errorBoxPersonActiveCards": {
    "name": "errorBoxPersonActiveCards",
    "characters": "This person has active cards",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxPersonActiveCardsText": {
    "name": "errorBoxPersonActiveCardsText",
    "characters": "It’s not possible to remove a person with active cards. Please remove cards before continue.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "errorBoxPersonExpenseApprover": {
    "name": "errorBoxPersonExpenseApprover",
    "characters": "This person is an expense approver",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxPersonExpenseApproverText": {
    "name": "errorBoxPersonExpenseApproverText",
    "characters": "It’s not possible to remove a person that’s an expense approver for a team. Please remove the person as expense approver before continue.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "bookTooltip": {
    "name": "bookTooltip",
    "characters": "Book",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cancelTooltip": {
    "name": "cancelTooltip",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditTooltip": {
    "name": "creditTooltip",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "remindTooltip": {
    "name": "remindTooltip",
    "characters": "Remind",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "debtCollectionTooltip": {
    "name": "debtCollectionTooltip",
    "characters": "Debt collection",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardFeatuersLabel": {
    "name": "cardFeatuersLabel",
    "characters": "Card features",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "orderCard": {
    "name": "orderCard",
    "characters": "Order card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "makeTopUps": {
    "name": "makeTopUps",
    "characters": "Make top-ups",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardCreditProduct": {
    "name": "cardCreditProduct",
    "characters": "Card credit product",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "approvalStatusLabel": {
    "name": "approvalStatusLabel",
    "characters": "Approval status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "appovalStatusText": {
    "name": "appovalStatusText",
    "characters": "Manually approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditLimitLabel": {
    "name": "creditLimitLabel",
    "characters": "Credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyCreditFeaturesLabel": {
    "name": "companyCreditFeaturesLabel",
    "characters": "Company credit features",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "reclaimCredit": {
    "name": "reclaimCredit",
    "characters": "Reclaim credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "addToCRMLink": {
    "name": "addToCRMLink",
    "characters": "+ Add to CRM",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "deleteCustomerLabel": {
    "name": "deleteCustomerLabel",
    "characters": "Delete customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "GeneralInfoHeading": {
    "name": "GeneralInfoHeading",
    "characters": "General info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "orgNumberLabel": {
    "name": "orgNumberLabel",
    "characters": "Organisation number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "addressCoLabel": {
    "name": "addressCoLabel",
    "characters": "Address co",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "cityLabel": {
    "name": "cityLabel",
    "characters": "City",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "invoiceEmailLabel": {
    "name": "invoiceEmailLabel",
    "characters": "Invoice email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "phoneNumberLabel": {
    "name": "phoneNumberLabel",
    "characters": "Phone number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "bankInfoHeading": {
    "name": "bankInfoHeading",
    "characters": "Bank info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "bankAccountLabel": {
    "name": "bankAccountLabel",
    "characters": "Bank account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "bankgiroLabel": {
    "name": "bankgiroLabel",
    "characters": "Bankgiro",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "AccountingInfoHeading": {
    "name": "AccountingInfoHeading",
    "characters": "Accounting info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingSystemLabel": {
    "name": "accountingSystemLabel",
    "characters": "Accounting system (direct)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "acquisitionChannelHeading": {
    "name": "acquisitionChannelHeading",
    "characters": "Acquisition channel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "channelLabel": {
    "name": "channelLabel",
    "characters": "Channel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "cardPartnerHeading": {
    "name": "cardPartnerHeading",
    "characters": "Card partner info",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardPartnerLabel": {
    "name": "cardPartnerLabel",
    "characters": "Card partner",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyIDLabel": {
    "name": "companyIDLabel",
    "characters": "Company ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyTokenLabel": {
    "name": "companyTokenLabel",
    "characters": "Company token",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "cardProductToolTipActiveStatus": {
    "name": "cardProductToolTipActiveStatus",
    "characters": "Token set",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "companyTokenEdit": {
    "name": "companyTokenEdit",
    "characters": "Edit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "KYC": {
    "name": "KYC",
    "characters": "KYC",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideLabel": {
    "name": "activationGuideLabel",
    "characters": "Activation guide",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardProductToolTipNotActiveStatus": {
    "name": "cardProductToolTipNotActiveStatus",
    "characters": "Token not set",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "companyOrgNum": {
    "name": "companyOrgNum",
    "characters": "557213-1235",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "cardProductToolTip": {
    "name": "cardProductToolTip",
    "characters": "Card product ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "CompanyCreditToolTip": {
    "name": "CompanyCreditToolTip",
    "characters": "Company credit product",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "KYCToolTipGreen": {
    "name": "KYCToolTipGreen",
    "characters": "KYC approved ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "KYCToolTipYellow": {
    "name": "KYCToolTipYellow",
    "characters": "KYC pending manual checks",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "KYCToolTipRed": {
    "name": "KYCToolTipRed",
    "characters": "KYC denied",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "KYCToolTipGrey": {
    "name": "KYCToolTipGrey",
    "characters": "KYC not done",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "KYCToolTipAnswered": {
    "name": "KYCToolTipAnswered",
    "characters": "KYC answered",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "orderCardToolTip": {
    "name": "orderCardToolTip",
    "characters": "Order card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "makeTopUpsToolTip": {
    "name": "makeTopUpsToolTip",
    "characters": "Make top-ups ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "CardCreditProductToolTip": {
    "name": "CardCreditProductToolTip",
    "characters": "Card credit product",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "orderedCardToolTip": {
    "name": "orderedCardToolTip",
    "characters": "Ordered card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "connectedAccountingToolTip": {
    "name": "connectedAccountingToolTip",
    "characters": "Connected accounting",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardCreditToolTip": {
    "name": "cardCreditToolTip",
    "characters": "Approved card credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "addedMoneyToolTip": {
    "name": "addedMoneyToolTip",
    "characters": "Added money",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "madePurchaseToolTip": {
    "name": "madePurchaseToolTip",
    "characters": "Made purchase",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideIncomplete": {
    "name": "activationGuideIncomplete",
    "characters": "Incomplete",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideComplete": {
    "name": "activationGuideComplete",
    "characters": "Completed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideHidden": {
    "name": "activationGuideHidden",
    "characters": "Hidden",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "companyTokenSave": {
    "name": "companyTokenSave",
    "characters": "Save",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureTextCompanyToken": {
    "name": "toolTipAreYouSureTextCompanyToken",
    "characters": "A new company token will be set and send to the server",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureYesDiscard": {
    "name": "toolTipAreYouSureYesDiscard",
    "characters": "Discard",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureTextTransactionNotify": {
    "name": "toolTipAreYouSureTextTransactionNotify",
    "characters": "This will send a transaction notification to the customer.\n",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureTextDeleteTinkConnection": {
    "name": "toolTipAreYouSureTextDeleteTinkConnection",
    "characters": "This will delete Tink connection.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "toolTipAreYouSureSendKYCEmail": {
    "name": "toolTipAreYouSureSendKYCEmail",
    "characters": "This will send a KYC approved email to the customer.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardProductToolTipStatusManuallyApproved": {
    "name": "cardProductToolTipStatusManuallyApproved",
    "characters": "Manually approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardProductToolTipStatusAutoApproved": {
    "name": "cardProductToolTipStatusAutoApproved",
    "characters": "Auto approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardProductToolTipStatusManuallyDenied": {
    "name": "cardProductToolTipStatusManuallyDenied",
    "characters": "Manually denied",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "cardProductToolTipStatusAutoDenied": {
    "name": "cardProductToolTipStatusAutoDenied",
    "characters": "Auto denied",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "cardProductToolTipStatusPending": {
    "name": "cardProductToolTipStatusPending",
    "characters": "Pending",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "kycStatusSetStatus": {
    "name": "kycStatusSetStatus",
    "characters": "Set status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycStatusGreen": {
    "name": "kycStatusGreen",
    "characters": "- Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycStatusYellow": {
    "name": "kycStatusYellow",
    "characters": "- Pending manual checks",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycStatusRed": {
    "name": "kycStatusRed",
    "characters": "- Denied",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycStatusGrey": {
    "name": "kycStatusGrey",
    "characters": "- Not answered",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycRiskLevel": {
    "name": "kycRiskLevel",
    "characters": "Risk level",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycRiskLevelLow": {
    "name": "kycRiskLevelLow",
    "characters": "Low",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycRiskLevelNormal": {
    "name": "kycRiskLevelNormal",
    "characters": "Normal",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycRiskLevelHigh": {
    "name": "kycRiskLevelHigh",
    "characters": "High",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycRiskLevelUnacceptable": {
    "name": "kycRiskLevelUnacceptable",
    "characters": "Unacceptable",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "KYCRefreshLabel": {
    "name": "KYCRefreshLabel",
    "characters": "Refresh owners and board members",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "KYCRefreshButton": {
    "name": "KYCRefreshButton",
    "characters": "Refresh",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "kycStatusLabel": {
    "name": "kycStatusLabel",
    "characters": "Set KYC status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "kycRiskAssesmentLabel": {
    "name": "kycRiskAssesmentLabel",
    "characters": "Risk assesment",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "kycSendKycEmailButton": {
    "name": "kycSendKycEmailButton",
    "characters": "Send KYC approved email",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingPayoutsToolTipBook": {
    "name": "accountingPayoutsToolTipBook",
    "characters": "Book",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingPayoutsToolTipCredit": {
    "name": "accountingPayoutsToolTipCredit",
    "characters": "Settle",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingPayoutsToolTipCancel": {
    "name": "accountingPayoutsToolTipCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "accountingPayoutsDate": {
    "name": "accountingPayoutsDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPayoutsState": {
    "name": "accountingPayoutsState",
    "characters": "State",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPayoutsCustomer": {
    "name": "accountingPayoutsCustomer",
    "characters": "Customer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPayoutsAmount": {
    "name": "accountingPayoutsAmount",
    "characters": "Amount (SEK)",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPayoutsExternalReference": {
    "name": "accountingPayoutsExternalReference",
    "characters": "External reference",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPayoutsType": {
    "name": "accountingPayoutsType",
    "characters": "Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPayoutsActions": {
    "name": "accountingPayoutsActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsOCR": {
    "name": "accountingPaymentsOCR",
    "characters": "OCR",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsState": {
    "name": "accountingPaymentsState",
    "characters": "State",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsDate": {
    "name": "accountingPaymentsDate",
    "characters": "Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsAmount": {
    "name": "accountingPaymentsAmount",
    "characters": "Amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsExternalSource": {
    "name": "accountingPaymentsExternalSource",
    "characters": "External source",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsExternalReference": {
    "name": "accountingPaymentsExternalReference",
    "characters": "External reference",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingPaymentsActions": {
    "name": "accountingPaymentsActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingYearsCreateYears": {
    "name": "accountingYearsCreateYears",
    "characters": "Create year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingAccountingCreateAccount": {
    "name": "accountingAccountingCreateAccount",
    "characters": "Create account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingVoucherCreateVoucher": {
    "name": "accountingVoucherCreateVoucher",
    "characters": "Create voucher",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tableLabel": {
    "name": "tableLabel",
    "characters": "tableLable",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 700,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "tableDetailInfoHeading": {
    "name": "tableDetailInfoHeading",
    "characters": "tableDetailInfoHeading",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tableDetailsInfo": {
    "name": "tableDetailsInfo",
    "characters": "tableDetailsInfo",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tableDetailsInfoSmallLable": {
    "name": "tableDetailsInfoSmallLable",
    "characters": "tableDetailsInfoSmallLable",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "tableDetailInfoLink": {
    "name": "tableDetailInfoLink",
    "characters": "tableDetailInfoLink",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "tooltipText": {
    "name": "tooltipText",
    "characters": "tooltipText",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "tableDetailInfoDesc": {
    "name": "tableDetailInfoDesc",
    "characters": "tableDetailInfoDesc",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tableDetailsInfoValue": {
    "name": "tableDetailsInfoValue",
    "characters": "tableDetailsInfoValue",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "tableDetailInfoHistoryValue": {
    "name": "tableDetailInfoHistoryValue",
    "characters": "tableDetailInfoHistoryValue",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "tableValue": {
    "name": "tableValue",
    "characters": "tableValue",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideToolTipNotStarted": {
    "name": "activationGuideToolTipNotStarted",
    "characters": "Not started",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideToolTipPending": {
    "name": "activationGuideToolTipPending",
    "characters": "Pending",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "activationGuideToolTipComplete": {
    "name": "activationGuideToolTipComplete",
    "characters": "Complete",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountHeading": {
    "name": "editAccountHeading",
    "characters": "Edit account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountNumberLabel": {
    "name": "editAccountNumberLabel",
    "characters": "Number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountNumberPlaceholder": {
    "name": "editAccountNumberPlaceholder",
    "characters": "Choose a number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editAccountNameLabel": {
    "name": "editAccountNameLabel",
    "characters": "Name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountNamePlaceholder": {
    "name": "editAccountNamePlaceholder",
    "characters": "Choose a name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editAccountAccountingYearLabel": {
    "name": "editAccountAccountingYearLabel",
    "characters": "Accounting year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountAccountingYearPlaceholderDefault": {
    "name": "editAccountAccountingYearPlaceholderDefault",
    "characters": "2021",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountCurrencyLabel": {
    "name": "editAccountCurrencyLabel",
    "characters": "Currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountCurrencyPlaceholderDefault": {
    "name": "editAccountCurrencyPlaceholderDefault",
    "characters": "SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountButtonCancel": {
    "name": "editAccountButtonCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountButtonSave": {
    "name": "editAccountButtonSave",
    "characters": "Save",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editYearHeading": {
    "name": "editYearHeading",
    "characters": "Edit year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editYearFromDateLabel": {
    "name": "editYearFromDateLabel",
    "characters": "From date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editYearFromDateLabelPlaceholder": {
    "name": "editYearFromDateLabelPlaceholder",
    "characters": "Select a from date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editYearToDateLabel": {
    "name": "editYearToDateLabel",
    "characters": "To date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editYearToDatePlaceholder": {
    "name": "editYearToDatePlaceholder",
    "characters": "Select a to date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editYearNameLabel": {
    "name": "editYearNameLabel",
    "characters": "Name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editYearNamePlaceholder": {
    "name": "editYearNamePlaceholder",
    "characters": "Choose a name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearNameDeafaultHeading": {
    "name": "createYearNameDeafaultHeading",
    "characters": "Use as default year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createYearNameDeafaultBody": {
    "name": "createYearNameDeafaultBody",
    "characters": "This year will be used as default when setting up new accounts",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearNameButtonCancel": {
    "name": "createYearNameButtonCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editYearButtonSave": {
    "name": "editYearButtonSave",
    "characters": "Save",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createYearHeading": {
    "name": "createYearHeading",
    "characters": "Create year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createYearFromDateLabel": {
    "name": "createYearFromDateLabel",
    "characters": "From date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createYearFromDateLabelPlaceholder": {
    "name": "createYearFromDateLabelPlaceholder",
    "characters": "Select a from date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearToDateLabel": {
    "name": "createYearToDateLabel",
    "characters": "To date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createYearToDatePlaceholder": {
    "name": "createYearToDatePlaceholder",
    "characters": "Select a to date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearNameLabel": {
    "name": "createYearNameLabel",
    "characters": "Name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createYearNamePlaceholder": {
    "name": "createYearNamePlaceholder",
    "characters": "Choose a name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearNameButtonCreate": {
    "name": "createYearNameButtonCreate",
    "characters": "Create",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createVoucherTransactionHeading": {
    "name": "createVoucherTransactionHeading",
    "characters": "Transactions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editAccountNumberError": {
    "name": "editAccountNumberError",
    "characters": "Please enter a number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editAccountNameError": {
    "name": "editAccountNameError",
    "characters": "Please enter a name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editAccountAccountingYearError": {
    "name": "editAccountAccountingYearError",
    "characters": "Please select an accounting year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editAccountCurrencyError": {
    "name": "editAccountCurrencyError",
    "characters": "Please select a currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearFromDateError": {
    "name": "createYearFromDateError",
    "characters": "Please select a from date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearToDateError": {
    "name": "createYearToDateError",
    "characters": "Please select a to date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createYearNameError": {
    "name": "createYearNameError",
    "characters": "Please enter a name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editYearFromDateError": {
    "name": "editYearFromDateError",
    "characters": "Please select a from date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editYearToDateError": {
    "name": "editYearToDateError",
    "characters": "Please select a to date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "editYearNameError": {
    "name": "editYearNameError",
    "characters": "Please enter a name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListAccountingYearLabel": {
    "name": "voucherListAccountingYearLabel",
    "characters": "Accounting year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListAccountingDateLabel": {
    "name": "voucherListAccountingDateLabel",
    "characters": "Accounting date\t",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListDescriptionLabel": {
    "name": "voucherListDescriptionLabel",
    "characters": "Description",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListNameLabel": {
    "name": "voucherListNameLabel",
    "characters": "Name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListNumberLabel": {
    "name": "voucherListNumberLabel",
    "characters": "Number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListInBalanceLabel": {
    "name": "voucherListInBalanceLabel",
    "characters": "In balance",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListPeriodLabel": {
    "name": "voucherListPeriodLabel",
    "characters": "Period",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListOutBalanceLabel": {
    "name": "voucherListOutBalanceLabel",
    "characters": "Out balance",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListAccountLabel": {
    "name": "voucherListAccountLabel",
    "characters": "Account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListDebitLabel": {
    "name": "voucherListDebitLabel",
    "characters": "Debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListCreditLabel": {
    "name": "voucherListCreditLabel",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "yearsDefaultLabel": {
    "name": "yearsDefaultLabel",
    "characters": "Default",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "voucherListTableText": {
    "name": "voucherListTableText",
    "characters": "Table text",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 600,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createVoucherHeading": {
    "name": "createVoucherHeading",
    "characters": "Create voucher",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createVouchersAccountingYearPlaceholder": {
    "name": "createVouchersAccountingYearPlaceholder",
    "characters": "Select a year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersAccountingYearLabel": {
    "name": "createVouchersAccountingYearLabel",
    "characters": "Accounting year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersAccountingDatePlaceholder": {
    "name": "createVouchersAccountingDatePlaceholder",
    "characters": "Set an accounting date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersAccountingDateLabel": {
    "name": "createVouchersAccountingDateLabel",
    "characters": "Accounting date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersCurrencyPlaceholder": {
    "name": "createVouchersCurrencyPlaceholder",
    "characters": "SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "0.2px",
          "lineHeight": "22px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "createVouchersCurrencyLabel": {
    "name": "createVouchersCurrencyLabel",
    "characters": "Currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersDescriptionPlaceholder": {
    "name": "createVouchersDescriptionPlaceholder",
    "characters": "Add a description",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "0.2px",
          "lineHeight": "22px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersDescriptionLabel": {
    "name": "createVouchersDescriptionLabel",
    "characters": "Description",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVoucherButtonCancel": {
    "name": "createVoucherButtonCancel",
    "characters": "Cancel",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createVoucherButtonSave": {
    "name": "createVoucherButtonSave",
    "characters": "Save",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "editVoucherHeading": {
    "name": "editVoucherHeading",
    "characters": "Edit voucher",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "Label": {
    "name": "Label",
    "characters": "Choose a number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersTransactionAccountLabel": {
    "name": "createVouchersTransactionAccountLabel",
    "characters": "Account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersTransactionDebitLabel": {
    "name": "createVouchersTransactionDebitLabel",
    "characters": "Debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersTransactionCreditLabel": {
    "name": "createVouchersTransactionCreditLabel",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVoucherAddNewTransactionLink": {
    "name": "createVoucherAddNewTransactionLink",
    "characters": "Add new transaction",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "vouchersAccountPlaceholder": {
    "name": "vouchersAccountPlaceholder",
    "characters": "Choose an account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersAccountLabel": {
    "name": "vouchersAccountLabel",
    "characters": "Account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersCurrencyPlaceholder": {
    "name": "vouchersCurrencyPlaceholder",
    "characters": "Choose a currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersCurrencyLabel": {
    "name": "vouchersCurrencyLabel",
    "characters": "Currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersYearPlaceholder": {
    "name": "vouchersYearPlaceholder",
    "characters": "Select a year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "0.2px",
          "lineHeight": "22px",
          "color": "rgba(51, 51, 51, 1)"
        }
      }
    }
  },
  "vouchersYearLabel": {
    "name": "vouchersYearLabel",
    "characters": "Year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersFromDatePlaceholder": {
    "name": "vouchersFromDatePlaceholder",
    "characters": "Set an date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersFromDateLabel": {
    "name": "vouchersFromDateLabel",
    "characters": "From date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersToDatePlaceholder": {
    "name": "vouchersToDatePlaceholder",
    "characters": "Set an date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersToDateLabel": {
    "name": "vouchersToDateLabel",
    "characters": "To date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "yearsHeading": {
    "name": "yearsHeading",
    "characters": "Years",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "32px",
          "fontWeight": 700,
          "letterSpacing": "-1px",
          "lineHeight": "35.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountHeading": {
    "name": "accountHeading",
    "characters": "Account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "32px",
          "fontWeight": 700,
          "letterSpacing": "-1px",
          "lineHeight": "35.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "vouchersHeading": {
    "name": "vouchersHeading",
    "characters": "Vouchers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "32px",
          "fontWeight": 700,
          "letterSpacing": "-1px",
          "lineHeight": "35.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "createVouchersAccountingYearError": {
    "name": "createVouchersAccountingYearError",
    "characters": "Please select a year",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersAccountingDateError": {
    "name": "createVouchersAccountingDateError",
    "characters": "Please select a date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersCurrencyError": {
    "name": "createVouchersCurrencyError",
    "characters": "Please select a currency",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersDescriptionError": {
    "name": "createVouchersDescriptionError",
    "characters": "Please add a description",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersSumEqualError": {
    "name": "createVouchersSumEqualError",
    "characters": "Sum of debit must be equal credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersCreateTransactionError": {
    "name": "createVouchersCreateTransactionError",
    "characters": "Please create transaction",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersAccountingAccountError": {
    "name": "createVouchersAccountingAccountError",
    "characters": "Please add an account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersDebitError": {
    "name": "createVouchersDebitError",
    "characters": "Please add debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "createVouchersCreditError": {
    "name": "createVouchersCreditError",
    "characters": "Please add credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "vouchersAccountError": {
    "name": "vouchersAccountError",
    "characters": "Please choose an account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditOnCardCreditSettingsHeading": {
    "name": "creditOnCardCreditSettingsHeading",
    "characters": "Credit settings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "20px",
          "fontWeight": 700,
          "letterSpacing": "-0.6px",
          "lineHeight": "24px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsCreditDetailsHeading": {
    "name": "creditSettingsCreditDetailsHeading",
    "characters": "Credit details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditLimitLabel": {
    "name": "creditSettingsMaxCreditLimitLabel",
    "characters": "Max credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditLimitValue": {
    "name": "creditSettingsMaxCreditLimitValue",
    "characters": "50 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditAvailableLabel": {
    "name": "creditSettingsMaxCreditAvailableLabel",
    "characters": "Credit available",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditAvailableValue": {
    "name": "creditSettingsMaxCreditAvailableValue",
    "characters": "26 451 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditUsedLabel": {
    "name": "creditSettingsMaxCreditUsedLabel",
    "characters": "Credit used",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditUsedValue": {
    "name": "creditSettingsMaxCreditUsedValue",
    "characters": "23 549 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsUpdateCreditHeading": {
    "name": "creditSettingsUpdateCreditHeading",
    "characters": "Update credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditSettingsUpdateCreditLabel": {
    "name": "creditSettingsUpdateCreditLabel",
    "characters": "Credit state",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditSettingsUpdateCreditPlaceholder": {
    "name": "creditSettingsUpdateCreditPlaceholder",
    "characters": "Choose a credit state",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditSettingsMaxCreditLimitPlaceholder": {
    "name": "creditSettingsMaxCreditLimitPlaceholder",
    "characters": "Set credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditOnCardCreditSettingsHeadingButtonUpdate": {
    "name": "creditOnCardCreditSettingsHeadingButtonUpdate",
    "characters": "Update credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditAgreementHeading": {
    "name": "creditAgreementHeading",
    "characters": "Credit agreement",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "20px",
          "fontWeight": 700,
          "letterSpacing": "-0.6px",
          "lineHeight": "24px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditAgreementGetDataLink": {
    "name": "creditAgreementGetDataLink",
    "characters": "Get data",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "creditAgreementDetailsHeading": {
    "name": "creditAgreementDetailsHeading",
    "characters": "Credit agreement details",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditAgreementStatusLabel": {
    "name": "creditAgreementStatusLabel",
    "characters": "Status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditAgreementAgreementIDLabel": {
    "name": "creditAgreementAgreementIDLabel",
    "characters": "Agreement ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditAgreementAgreementIDLink": {
    "name": "creditAgreementAgreementIDLink",
    "characters": "49485543",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "creditAgreementSentDate": {
    "name": "creditAgreementSentDate",
    "characters": "Sent date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditAgreementSentDateValue": {
    "name": "creditAgreementSentDateValue",
    "characters": "March 15, 2022",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementHeading": {
    "name": "setUpCreditAgreementHeading",
    "characters": "Set up credit agreement",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementAgreementDateLabel": {
    "name": "setUpCreditAgreementAgreementDateLabel",
    "characters": "Agreement date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditAgreementCreditLimitPlaceholder": {
    "name": "creditAgreementCreditLimitPlaceholder",
    "characters": "Select a date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementCreditLimitLabel": {
    "name": "setUpCreditAgreementCreditLimitLabel",
    "characters": "Credit limit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementCreditLimitPlaceholder": {
    "name": "setUpCreditAgreementCreditLimitPlaceholder",
    "characters": "Enter in SEK",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementAnnualInterestRateLabel": {
    "name": "setUpCreditAgreementAnnualInterestRateLabel",
    "characters": "Annual interest rate",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementAnnualInterestRatePlaceholder": {
    "name": "setUpCreditAgreementAnnualInterestRatePlaceholder",
    "characters": "0",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementFixedFeeLabel": {
    "name": "setUpCreditAgreementFixedFeeLabel",
    "characters": "Fixed fee",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementFixedFeePlaceoholder": {
    "name": "setUpCreditAgreementFixedFeePlaceoholder",
    "characters": "0",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementPaymentMethodDefaultPlaceholder": {
    "name": "setUpCreditAgreementPaymentMethodDefaultPlaceholder",
    "characters": "Autogiro",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementIdentificationMethodLabel": {
    "name": "setUpCreditAgreementIdentificationMethodLabel",
    "characters": "Identification method",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementIdentificationMethodDefaultPlaceholder": {
    "name": "setUpCreditAgreementIdentificationMethodDefaultPlaceholder",
    "characters": "Swedish BankID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementPersonalGuarantorsLabel": {
    "name": "setUpCreditAgreementPersonalGuarantorsLabel",
    "characters": "Personal guarantors",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditAgreementGuarantorsPlaceholder": {
    "name": "creditAgreementGuarantorsPlaceholder",
    "characters": "Choose a personal guarantor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementSignatoriesLabel": {
    "name": "setUpCreditAgreementSignatoriesLabel",
    "characters": "Signatories",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementBankAccountLabel": {
    "name": "setUpCreditAgreementBankAccountLabel",
    "characters": "Bank account",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementDirectDebitStatusLabel": {
    "name": "setUpCreditAgreementDirectDebitStatusLabel",
    "characters": "Direct debit status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementOtherTermsLabel": {
    "name": "setUpCreditAgreementOtherTermsLabel",
    "characters": "Other terms",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "setUpCreditAgreementOtherTermsPlaceholder": {
    "name": "setUpCreditAgreementOtherTermsPlaceholder",
    "characters": "Enter other terms",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyGuarantorHeading": {
    "name": "companyGuarantorHeading",
    "characters": "Company guarantor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "companyGuarantorNameLabel": {
    "name": "companyGuarantorNameLabel",
    "characters": "Company name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyGuarantorNamePlaceholder": {
    "name": "companyGuarantorNamePlaceholder",
    "characters": "Enter a company name",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyGuarantorRegNumLabel": {
    "name": "companyGuarantorRegNumLabel",
    "characters": "Company reg. number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "companyGuarantorRegNumPlaceholder": {
    "name": "companyGuarantorRegNumPlaceholder",
    "characters": "Enter reg. number for guarantor",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "creditAgreementButtonSave": {
    "name": "creditAgreementButtonSave",
    "characters": "Save",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditAgreementButtonSend": {
    "name": "creditAgreementButtonSend",
    "characters": "Send credit agreement",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditRequestHeading": {
    "name": "creditRequestHeading",
    "characters": "Credit request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditRequestLink": {
    "name": "creditRequestLink",
    "characters": "Clear request",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "creditRequestBody": {
    "name": "creditRequestBody",
    "characters": "I need 500 000 kr in credit to repair the washing machine",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "earlierCreditAgreementHeadline": {
    "name": "earlierCreditAgreementHeadline",
    "characters": "Earlier sent credit agreements",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "earlierCreditAgreementNumberLink": {
    "name": "earlierCreditAgreementNumberLink",
    "characters": "49485543",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "earlierCreditAgreementDate": {
    "name": "earlierCreditAgreementDate",
    "characters": "2021-04-16",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "tabNotSelected": {
    "name": "tabNotSelected",
    "characters": "Settings",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "creditAgreementStatusSent": {
    "name": "creditAgreementStatusSent",
    "characters": "Sent",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(0, 107, 143, 1)"
        }
      }
    }
  },
  "creditAgreementStatusPartialSigned": {
    "name": "creditAgreementStatusPartialSigned",
    "characters": "Partial signed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(9, 93, 58, 1)"
        }
      }
    }
  },
  "creditAgreementStatusFullySigned": {
    "name": "creditAgreementStatusFullySigned",
    "characters": "Fully signed",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "searchExportPlaceholder": {
    "name": "searchExportPlaceholder",
    "characters": "Search transaction...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paginationResults": {
    "name": "paginationResults",
    "characters": "Results: XXX - XXX of XXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paginationResultsAmount": {
    "name": "paginationResultsAmount",
    "characters": "XXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paginationPagePrevInactive": {
    "name": "paginationPagePrevInactive",
    "characters": "Prev",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(216, 216, 218, 1)"
        }
      }
    }
  },
  "paginationPageSelected": {
    "name": "paginationPageSelected",
    "characters": "1",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "paginationPageNotSelected": {
    "name": "paginationPageNotSelected",
    "characters": "2",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "exportActionBarDeselect": {
    "name": "exportActionBarDeselect",
    "characters": "...",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "paginationPageNext": {
    "name": "paginationPageNext",
    "characters": "Next",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionDate": {
    "name": "transactionDate",
    "characters": "2023-07-04",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "transactionVendor": {
    "name": "transactionVendor",
    "characters": "Apple",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionAmount": {
    "name": "transactionAmount",
    "characters": "-123 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionMemberCard": {
    "name": "transactionMemberCard",
    "characters": "Member & Card",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionStatusType": {
    "name": "transactionStatusType",
    "characters": "Status / Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionAttestStatus": {
    "name": "transactionAttestStatus",
    "characters": "Attest status",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "transactionActions": {
    "name": "transactionActions",
    "characters": "Actions",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "exportPaymentDate": {
    "name": "exportPaymentDate",
    "characters": "2021-04-16",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "exportVendorName": {
    "name": "exportVendorName",
    "characters": "Apple Inc.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "exportAmountSEK": {
    "name": "exportAmountSEK",
    "characters": "- 9 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "exportAmountUSD": {
    "name": "exportAmountUSD",
    "characters": "- 800 USD",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "exportMemberName": {
    "name": "exportMemberName",
    "characters": "Johan Obermayer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "exportTeam": {
    "name": "exportTeam",
    "characters": "0456 - Google Ads",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 400,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "underReviewBadge": {
    "name": "underReviewBadge",
    "characters": "Under review",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "rejectedBadge": {
    "name": "rejectedBadge",
    "characters": "Rejected",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "approvedBadge": {
    "name": "approvedBadge",
    "characters": "Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "exportBadge": {
    "name": "exportBadge",
    "characters": "Exported",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "cancelledBadge": {
    "name": "cancelledBadge",
    "characters": "Cancelled",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "rejectedStatusTypeBadge": {
    "name": "rejectedStatusTypeBadge",
    "characters": "Rejected",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "settledBadge": {
    "name": "settledBadge",
    "characters": "Settled",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "pendingBadge": {
    "name": "pendingBadge",
    "characters": "Pending",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "cardCreditRepaymentBadge": {
    "name": "cardCreditRepaymentBadge",
    "characters": "Card credit rep.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(9, 93, 58, 1)"
        }
      }
    }
  },
  "unknownBadge": {
    "name": "unknownBadge",
    "characters": "Unknown",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(0, 107, 143, 1)"
        }
      }
    }
  },
  "topUpBadge": {
    "name": "topUpBadge",
    "characters": "Top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(9, 93, 58, 1)"
        }
      }
    }
  },
  "creditUsageTopUpBadge": {
    "name": "creditUsageTopUpBadge",
    "characters": "Credit usage top-up",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(9, 93, 58, 1)"
        }
      }
    }
  },
  "accountSearchButton": {
    "name": "accountSearchButton",
    "characters": "Search",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountXAccountingAccaountAcountingVoucherNumberTitle": {
    "name": "accountXAccountingAccaountAcountingVoucherNumberTitle",
    "characters": "accountXAccountingAccaountAcountingVoucherNumberTitle",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "accountXAccountingAccaountAcountingVoucherDateTitle": {
    "name": "accountXAccountingAccaountAcountingVoucherDateTitle",
    "characters": "2021-04-03",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "accountingInvoicesInvoiceDebit": {
    "name": "accountingInvoicesInvoiceDebit",
    "characters": "Debit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "accountingInvoicesCredit": {
    "name": "accountingInvoicesCredit",
    "characters": "Credit",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "BackOffice": {
    "name": "BackOffice",
    "characters": "BackOffice",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "32px",
          "fontWeight": 700,
          "letterSpacing": "-1px",
          "lineHeight": "35.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "headerInbox": {
    "name": "headerInbox",
    "characters": "Inbox",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "headerLeadCheck": {
    "name": "headerLeadCheck",
    "characters": "Lead check",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "headerCustomers": {
    "name": "headerCustomers",
    "characters": "Customers",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "headerCredits": {
    "name": "headerCredits",
    "characters": "Credits",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "headerBidding": {
    "name": "headerBidding",
    "characters": "Bidding",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "headerAccountX": {
    "name": "headerAccountX",
    "characters": "AccountX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(0, 128, 96, 1)"
        }
      }
    }
  },
  "headerLogOut": {
    "name": "headerLogOut",
    "characters": "Log out",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "CustomerInvoicesTopupReference": {
    "name": "CustomerInvoicesTopupReference",
    "characters": "Topup reference: XXX",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "customerInvoicesHeading": {
    "name": "customerInvoicesHeading",
    "characters": "Customer invoices",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "22px",
          "fontWeight": 700,
          "letterSpacing": "-0.7px",
          "lineHeight": "26.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitTagPending": {
    "name": "directDebitTagPending",
    "characters": "Pending",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitRefreshButton": {
    "name": "directDebitRefreshButton",
    "characters": "Refresh",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "agreementIdLabelIBAN": {
    "name": "agreementIdLabelIBAN",
    "characters": "Agreement Id",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "signingDateLabelIBAN": {
    "name": "signingDateLabelIBAN",
    "characters": "Signing Date",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "directDebitTagFail": {
    "name": "directDebitTagFail",
    "characters": "Fail",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitTagApproved": {
    "name": "directDebitTagApproved",
    "characters": "Approved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitTagReady": {
    "name": "directDebitTagReady",
    "characters": "Ready",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitTagRequested": {
    "name": "directDebitTagRequested",
    "characters": "Requested",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "DirectDebitDetailsBankAccountIBAN": {
    "name": "DirectDebitDetailsBankAccountIBAN",
    "characters": "IBAN",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "autoTopUpModalformAddaNumber": {
    "name": "autoTopUpModalformAddaNumber",
    "characters": "Add a number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Open Sans",
          "fontSize": "12px",
          "fontWeight": 400,
          "letterSpacing": "0.4px",
          "lineHeight": "10px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "mFenterBankAccountError": {
    "name": "mFenterBankAccountError",
    "characters": "Add bank account number",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "directDebitTagCancelled": {
    "name": "directDebitTagCancelled",
    "characters": "Cancelled",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitStatusLogHeading": {
    "name": "directDebitStatusLogHeading",
    "characters": "Direct debit Log",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitLog": {
    "name": "directDebitLog",
    "characters": "xxx",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "directDebitOpenAltarButton": {
    "name": "directDebitOpenAltarButton",
    "characters": "Open Altar",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "directDebitCopyLogButton": {
    "name": "directDebitCopyLogButton",
    "characters": "Copy",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.2px",
          "color": "rgba(13, 130, 81, 1)"
        }
      }
    }
  },
  "reservedBadge": {
    "name": "reservedBadge",
    "characters": "Reserved",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "monthlySpendInfoOverview": {
    "name": "monthlySpendInfoOverview",
    "characters": "Spend this month 2592 kr ",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 700,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionName": {
    "name": "transactionName",
    "characters": "Johan Obermayer",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "transactionTableId": {
    "name": "transactionTableId",
    "characters": "ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableIdValue": {
    "name": "transactionTableIdValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableExternalLinkId": {
    "name": "transactionTableExternalLinkId",
    "characters": "External link ID",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableExternalLinkIdValue": {
    "name": "transactionTableExternalLinkIdValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableOriginalAmount": {
    "name": "transactionTableOriginalAmount",
    "characters": "Original amount",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableOriginalAmountValue": {
    "name": "transactionTableOriginalAmountValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableCardType": {
    "name": "transactionTableCardType",
    "characters": "Card Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableCardTypeValue": {
    "name": "transactionTableCardTypeValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableResponseCode": {
    "name": "transactionTableResponseCode",
    "characters": "Response code",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableResponseCodeValue": {
    "name": "transactionTableResponseCodeValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableConditionCode": {
    "name": "transactionTableConditionCode",
    "characters": "Condition code",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableConditionCodeValue": {
    "name": "transactionTableConditionCodeValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableType": {
    "name": "transactionTableType",
    "characters": "Transaction Type",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "transactionTableTypeValue": {
    "name": "transactionTableTypeValue",
    "characters": "123",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "dropDownLanguageFinnish": {
    "name": "dropDownLanguageFinnish",
    "characters": "Suomi",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "dropdownLanguageEnglish": {
    "name": "dropdownLanguageEnglish",
    "characters": "English",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "dropdownLanguageSwedish": {
    "name": "dropdownLanguageSwedish",
    "characters": "Svenska",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "dropdownLanguageFigma": {
    "name": "dropdownLanguageFigma",
    "characters": "Figma",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "18px",
          "fontWeight": 500,
          "letterSpacing": "-0.4px",
          "lineHeight": "18px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "errorBoxYouAreOffline": {
    "name": "errorBoxYouAreOffline",
    "characters": "You’re offline",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxYouAreOfflineText": {
    "name": "errorBoxYouAreOfflineText",
    "characters": "Check you connection and try again.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "errorBoxPrivateBrowser": {
    "name": "errorBoxPrivateBrowser",
    "characters": "Browser in private mode",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxPrivateBrowserText": {
    "name": "errorBoxPrivateBrowserText",
    "characters": "Change to normal mode to continue",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "notificationBoxCopiedToClipboard": {
    "name": "notificationBoxCopiedToClipboard",
    "characters": "Copied to clipboard",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "notificationBoxInvite": {
    "name": "notificationBoxInvite",
    "characters": "Invite successfully sent",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "notificationBoxUploadReceipt": {
    "name": "notificationBoxUploadReceipt",
    "characters": "Your receipt is uploaded",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxFallBelowValue": {
    "name": "errorBoxFallBelowValue",
    "characters": "Fall below value too low",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxFallBelowValueText": {
    "name": "errorBoxFallBelowValueText",
    "characters": "Fall below value must be at least 5 000 kr",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "errorBoxSomething": {
    "name": "errorBoxSomething",
    "characters": "Oops, something went wrong",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(0, 0, 0, 1)"
        }
      }
    }
  },
  "errorBoxSomethingText": {
    "name": "errorBoxSomethingText",
    "characters": "We’re working on it, try again later.",
    "variants": {
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "12px",
          "fontWeight": 500,
          "letterSpacing": "-0.2px",
          "lineHeight": "16.8px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "lableGeneric": {
    "name": "lableGeneric",
    "characters": "GenericLabel",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "errorGeneric": {
    "name": "errorGeneric",
    "characters": "GenericError",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(244, 67, 54, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(244, 67, 54, 1)"
        }
      }
    }
  },
  "placeholderGeneric": {
    "name": "placeholderGeneric",
    "characters": "GenericPlaceholder",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "placeholderGenericDropdown": {
    "name": "placeholderGenericDropdown",
    "characters": "GenericPlaceholderDropdown",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "statusBadgePaused": {
    "name": "statusBadgePaused",
    "characters": "Paused",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "statusBadgeActive": {
    "name": "statusBadgeActive",
    "characters": "Active",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "statusBadgePending": {
    "name": "statusBadgePending",
    "characters": "Pending",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(120, 83, 13, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(120, 83, 13, 1)"
        }
      }
    }
  },
  "statusBadgeError": {
    "name": "statusBadgeError",
    "characters": "Error",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(255, 255, 255, 1)"
        }
      }
    }
  },
  "statusBadgeInactive": {
    "name": "statusBadgeInactive",
    "characters": "Inactive",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(104, 103, 106, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "GenericTertiaryButton": {
    "name": "GenericTertiaryButton",
    "characters": "GenericTertiaryButton",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(27, 28, 31, 1)"
        }
      }
    }
  },
  "GenericTertiaryButtonDisable": {
    "name": "GenericTertiaryButtonDisable",
    "characters": "GenericTertiaryButtonDisable",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      }
    }
  },
  "textLinkInactive": {
    "name": "textLinkInactive",
    "characters": "Freeze",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Manrope",
          "fontSize": "16px",
          "fontWeight": 600,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(120, 120, 122, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "16px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "22.4px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  },
  "statusBadgeRequested": {
    "name": "statusBadgeRequested",
    "characters": "Requested",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(120, 83, 13, 1)"
        }
      },
      "VariantDesktop": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "lineHeight": "16.8px",
          "color": "rgba(120, 83, 13, 1)"
        }
      }
    }
  },
  "smallScreenInfoHeading": {
    "name": "smallScreenInfoHeading",
    "characters": "We have too much to show you!",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Mynt Sans Display",
          "fontSize": "20px",
          "fontWeight": 500,
          "lineHeight": "24px",
          "color": "rgba(28, 27, 31, 1)"
        }
      }
    }
  },
  "smallScreenInfo": {
    "name": "smallScreenInfo",
    "characters": "Please come back when you’re on a desktop.",
    "variants": {
      "VariantMobile": {
        "style": {
          "fontFamily": "Inter",
          "fontSize": "14px",
          "fontWeight": 500,
          "letterSpacing": "-0.3px",
          "lineHeight": "19.6px",
          "color": "rgba(104, 103, 106, 1)"
        }
      }
    }
  }
}
